export const LANG_ES_NAME = 'spanish';
export const LANG_ES_TRANS = {
  'Loading': 'Cargando',
  'Dashboard': 'Tablero',
  'My Equipment': 'Mi Equipo',
  'My Inventory': 'Mi Inventario',
  'Reports': 'Reportes',
  'Admin': 'Administración',
  'TT Admin': 'TT Administración',
  'My Account': 'Mi Cuenta',
  'Help': 'Ayuda',
  'Inspections': 'Inspecciones',
  'New Inspection': 'Nueva Inspección',
  'Find & Edit Inspection': 'Buscar y Editar Inspección',
  'Interpret Inspection': 'Interpretar Inspección',
  'Inspection Planning': 'Planificación de inspecciones',
  'Download Android App': 'Descargar la aplicación para Android',
  'Full History': 'Historia Completa',
  'Record an Action': 'Grabar una Acción',
  'Meter Reading': 'Lectura del Horómetro',
  'Meter Change': 'Cambio del Horómetro',
  'Setup New Equipment': 'Configurar Equipo Nuevo',
  'Find & Edit Equipment': 'Buscar y Editar Equipo',
  'Relocate Equipment': 'Reubicar Equipo',
  'Inventory': 'Inventario',
  'New Chain or Frame': 'Nueva Cadena o Chasis',
  'Inspection Analysis': 'Análisis de Inspección',
  'Component Life Performance': 'Desempenpo vida de Componentes',
  'Equipment Without Contacts': 'Equipo Sin Contactos',
  'Login Statistics': 'Estadísticas Inico de Sesión',
  'Fleet Component Forecast': 'Pronóstico de Componentes',
  'Home': 'Inicio',
  'Customer Contacts': 'Contactos del Cliente',
  'User Contacts': 'Contactos de Usuario',
  'Job Roles': 'Roles de Trabajo',
  'Components': 'Componentes',
  'COMPONENTS': 'COMPONENTES',
  'Equipment': 'Equipo',
  'Branded Styles': 'Estilos de Marca',
  'Old Setup': 'Antigua Configuración',
  'Preferences': 'Preferencias',
  'Logout': 'Cerrar Sesión',
  'TrackCommander Documentation': 'Documentación TrackCommander',
  'What\'s New': 'Qué hay de Nuevo',
  'About': 'Acerca de',
  'Job Role Setup': 'Configuración de Roles de trabajo',
  'Job Role Permissions': 'Permisos para Roles de trabajo',
  'Job Role Members': 'Miembros de Roles de trabajo',
  'Position & Job Status': 'Posición y estado de los trabajos',
  'Component Types': 'Tipos de Componentes',
  'Setup Components': 'Configuración de Componentes',
  'Wear Limits (A,B,C,X),': 'Límites de Desgaste (A, B, C, X),',
  'Wear Rate Formulas': 'Fórmulas de Desgaste',
  'Setup Families': 'Configuración de Familias',
  'Setup Makes': 'Configuración de Marcas',
  'Setup Models': 'Configuración de Modelos',
  'Customer': 'Cliente',
  'User': 'Usuario',
  'Search': 'Buscar',
  'Job Site': 'Sitio de Trabajo',
  'Equipment Serial/Unit No': 'Número de Serie y Unidad del Equipo',
  'Family': 'Familia',
  'Make': 'Marca',
  'Model': 'Modelo',
  'Fleet Overview': 'Vista General de Flota',
  'Filter': 'Filtrar',
  'Filter Table': 'Filtrar Tabla',
  'Eval (L)': 'Eval (Izq)',
  'Eval (R)': 'Eval (Der)',
  'Serial No.': 'Número de Serie.',
  'Unit No.': 'Número de Unidad.',
  'SMU': 'SMU',
  'LTD': 'LTD',
  'Last Inspection Date': 'Fecha de última Inspección',
  'Last Inspect Date': 'Fecha de última Inspección',
  'Back': 'Atras',
  'Awaiting Interpretation': 'Esperando por Interpretación',
  'This machine has recently been inspected, but the report is not ready. Once interpreted, your PDF report will be available for download.': 'Esta máquina ha sido inspeccionada recientemente, pero el informe no está listo. Una vez interpretado, su informe PDF estará disponible para su descarga.',
  'Equipment Details': 'Detalles del Equipo',
  'Download Report': 'Descargar Reporte',
  'Inspection Details': 'Detalles de Inspección',
  'Find Inspection': 'Buscar Inspección',
  'Equipment History': 'Historia de Equipo',
  'Record Action': 'Registrar Acción',
  'Serial Number': 'Número de Serie',
  'Unit Number': 'Número de Unidad',
  'Next Inspection Date': 'Siguiente Fecha de Inspección',
  'N/A': 'N / A',
  'Meter Reading (SMU)': 'Lectura de SMU/Horómetro',
  'Life to Date (LTD)': 'Vida hasta la Fecha (LTD)',
  'Chain Serial Number (left)': 'Número de Serie Cadena (Izq)',
  'Frame Serial Number (left)': 'Número de Serie Marco (Izq)',
  'Chain Serial Number (right)': 'Número de Serie Cadena (Der)',
  'Frame Serial Number (right)': 'Número de Serie Marco (Der)',
  'Left Side Components': 'Componentes del Lado Izquierdo',
  'Worn (%)': 'Desgaste (%)',
  'Component': 'Componente',
  'Part No.': 'Nº de Pieza',
  'Life Lived (CMU)': 'Vida Vivida (CMU)',
  'Remaining Life (100%)': 'Vida Restante (100%)',
  'Remaining Life (120%)': 'Vida Restante (120%)',
  'Install Date': 'Fecha de Instalación',
  'Equipment SMU at Install': 'SMU/Horómetro del Equipo durante la Instalación',
  'Component Hours at Install': 'Horas de Componentes durante la Instalación',
  'Right Side Components': 'Componentes del Lado Derecho',
  '': '',
  'Ruler': 'Regla',
  'Create Favourite': 'Crear Favorito',
  'Component Overview': 'Vista General Componente',
  'Wear Rate Overview': 'Vista General Desgaste',
  'Recommendation': 'Recomendación',
  'Status': 'Estado',
  'Position': 'Posición',
  'Type': 'Tipo',
  'Track Roller Values -': 'Valores de Rodillos -',
  'Left': 'Izquierda',
  'Right': 'Derecha',
  'hrs': 'hrs',
  'No': 'No',
  'Yes': 'Sí',
  'Carrier Roller AVG': 'Rodillo Superior Promedio',
  'Track Roller AVG': 'Rodillo Inferior Promedio',
  'Track Roller Worst': 'Peor Rodillo Inferior',
  'Outstanding Actions': 'Acciones Pendientes',
  'Sprocket': 'Engranaje',
  'Rear Idler': 'Rueda Guia Trasera',
  'Front Idler': 'Rueda Guia Delantera',
  'Shoe': 'Zapato',
  'Bush Turned': 'Juntas Rotadas',
  'Bush': 'Juntas',
  'Hours on Link': 'Horas en la Cadena',
  'Link': 'Cadena',
  'Current SMU/Hourmeter': 'SMU/Horometro Actual',
  'Site': 'Sitio',
  'Unit': 'Unidad',
  'Serial': 'Serial',
  'Update to Current Selection': 'Actualizar a la Selección Actual',
  'Setup Undercarriage': 'Configuración de Carrileria',
  'On Equipment': 'En Equipo',
  'In Inventory': 'En Inventario',
  'Setup User': 'Configuración de Usuario',
  'Setup Customer': 'Configuración del Cliente',
  'Setup Job Site': 'Configuración del Sitio de Trabajo',
  'Observation Lists': 'Listas de Observación',
  'Measurement Points': 'Puntos de Medición',
  'Switch App': 'Cambiar de Aplicacion',
  'Dashboard Overview': 'Vista General Tablero',
  'Enlarge': 'Agrandar',
  'Inspections Performed': 'Inspecciones Realizadas',
  'Total cost of all repairs recorded each month for the past year. This does not include cost of new equipment or parts. Filter this data down using the search above.': 'Costo Total de todas las reparaciones registradas cada mes durante el año pasado. Esto no incluye el costo de los nuevos equipos o piezas. Filtrar estos datos usando la búsqueda arriba.',
  'Total Cost of Repairs': 'Costo Total de Reparaciones',
  'The current evaluation of all the components you can view based on their last inspection. Filter this data down using the search above.': 'La evaluación actual de todos los componentes se puede ver basada en la última inspección. Filtrar estos datos usando la búsqueda arriba.',
  'Inspections are due by today date. This is based on what you searched for in total and not what you see in this page only.': 'Las inspecciones pendientes a el día de hoy. Esto se basa en lo que ha buscado en total y no lo que se ve sólo en esta página.',
  'Inspections due': 'Inspecciones Pendientes',
  'undefined': 'Indefinido',
  'Last Inspection SMU/Hourmeter': 'SMU/Horómetro de última Inspección',
  'SMU/Hourmeter': 'SMU/Horómetro',
  'Fleet Condition': 'Vista General Flota',
  'Equipment Overview': 'Vista General Equipo',
  'Meter Reading (SMU/HourMeter)': 'Lectura de SMU/Horómetro',
  'Setup Date': 'Configurar Fecha',
  'Details': 'Detalles',
  'Edit': 'Editar',
  'Interpret': 'Interpretar',
  'Inspection History': 'Historia de Inspección',
  'Change Meter Unit': 'Cambio de Horómetro',
  'Update Meter': 'Actualizar Horómetro',
  'Life Lived': 'Vida Vivida',
  'Equipment SMU/Hourmeter at Install': 'SMU/Horómetro de Equipo durante Instalación',
  'Date Installed': 'Fecha de Instalación',
  'Total Component Repairs Cost (inc. All Components Ever)': 'Costo Total de Reparación de Componentes (inc. Todos los Componentes)',
  'Total Purchase Cost (inc. Current Components)': 'Costo Total de Compra (inc. Componentes Actuales)',
  'Right Side Frame': 'Marco de la Derecha',
  'Right Side Chain': 'Cadena de la Derecha',
  'Left Side Frame': 'Marco de la Izquierda',
  'Left Side Chain': 'Cadena de la Izquierda',
  'PDF Report': 'Reporte PDF',
  'Tasks': 'Tareas',
  'Change Jobsite': 'Cambiar Lugar de Trabajo',
  'Setup Equipment': 'Configuración de Equipo',
  'Next Inspection': 'Proxima Inspección',
  'Brand': 'Marca',
  '(CMU)': '(CMU) Horas en Componente',
  '(100% Worn)': '(100% Desgaste)',
  '(120% Worn)': '(120% Desgaste)',
  'Purchase Cost': 'Costo de la Compra',
  'Repairs Cost': 'Costo Reparaciones',
  'Interpretation': 'Interpretación',
  'Manage Equipment': 'Administración de Equipo',
  'Meter Reading (SMU/Hourmeter)': 'Lectura del SMU/Horómetro',
  'Forward Travel Km': 'Km hacia Adelante',
  'Reverse Travel Km': 'Km en Reversa',
  'Forward Hours': 'Horas hacia Adelante',
  'Reverse Hours': 'Horas en Reversa',
  'JobSite Comment': 'Comentario del Sitio de Trabajo',
  'Inspection Comment': 'Comentario de la Inspección',
  'Inspector': 'Inspector',
  'Inspection Date': 'Fecha de Inspección',
  'Cannon Ext.': 'Extencion del Cañón',
  'Dry Joints': 'Junta Secas',
  'Scallop': 'Deformacion de Eslabón',
  'Add Comment': 'Agregar Comentario',
  'Interpretation Comment': 'Comentario de Interpretación',
  'Create New Quote': 'Crear Nueva Cotización',
  'There are currently no quotes.': 'Actualmente no hay cotizacion.',
  'Quotes': 'Cotizaciones',
  'Bar Chart': 'Gráfico de Barras',
  'Additional Observations': 'Observaciones Adicionales',
  'Audit Log': 'Registro de Auditoría',
  'Quote': 'Cotizaciones',
  'Release': 'Liberar',
  'Release Report to Customer': 'Liberar Reporte al Cliente',
  'PDF': 'PDF',
  'Depth Gauge': 'Medidor de Profundidad',
  'UT': 'Ultrasonido',
  'Eval': 'Eval',
  'Change tool': 'Cambio de Herramienta',
  'Add photo': 'Añadir Foto',
  'CMU': 'CMU',
  'Tool': 'Herramienta',
  'Residual Life': 'Vida Residual',
  'Select Customer': 'Seleccione Cliente',
  'Select Filter': 'Seleccione Filtro',
  'Customer Notes': 'Notas del Cliente',
  'Add New': 'Añadir Nuevo',
  'Address To Customer Name': 'Dirección Para Nombre del Cliente',
  'Created Date': 'Fecha de Creación',
  'Notes': 'Notas',
  'Created By': 'Creado por',
  'Select Job Site': 'Seleccionar Sitio de Trabajo',
  'Select Equipment': 'Seleccionar Equipo',
  'Next': 'Siguiente',
  'Save And Interpret': 'Guardar e Interpretar',
  'Change Equipment': 'Cambiar Equipo',
  'Review & Save': 'Revisar y Guardar',
  'General Information': 'Información General',
  'Abrasive *': 'Abrasivo *',
  'Impact *': 'Impacto *',
  'Moisture *': 'Humedad *',
  'Packing *': 'Embalaje *',
  'Observations': 'Observaciones',
  'Reverse Travel Kms': 'Kms en Reversa',
  'Reverse Travel hrs': 'Hrs en Reversa',
  'Inspection Date *': 'Fecha de Inspección *',
  'Meter Reading(SMU/Hourmeter) *': 'Lectura de SMU/Horómetro *',
  'Inches': 'Pulgadas',
  'Change Measurement Unit': 'Cambio de Unidad de Medida',
  'Photo': 'Foto',
  'Comment': 'Comentário',
  'Equipment Hours': 'SMU/Horómetro de Equipo',
  'Forward Travel hrs': 'Hrs hacia Adelante',
  'Forward Travel Kms': 'Kms hacia Adelante',
  'Overall Notes': 'Notas Generales',
  'Inspection Notes': 'Notas de Inspección',
  'Jobsite Notes': 'Notas del Sitio de Trabajo',
  'Underfoot Conditions': 'Condiciones del Terreno',
  'Left Chain': 'Cadena de la Izquierda',
  'Right Chain': 'Cadena de la Derecha',
  'Left Frame': 'Marco de la Izquierda',
  'Right Frame': 'Marco de la Derecha',
  'Worn(%)': 'Desgaste (%)',
  'Measurement': 'Medición',
  'MM': 'mm',
  'There are currently no recommendations added for this quote.': 'Actualmente no hay recomendaciones adicionales para esta cotización',
  'Calipers': 'Calibrador',
  'Pos.': 'Pos.',
  'Pos': 'Pos.',
  'Worn': 'Desgaste',
  'Unsynced Inspections': 'Inspecciones no Sincronizadas',
  'Workshop Repair Estimates': 'Estimaciones de Reparación',
  'Evaluation': 'Evaluación',
  'Select Model': 'Seleccione el Modelo',
  'Select Make': 'Seleccione Marca',
  'Jobsite': 'Sitio de Trabajo',
  'Condition': 'Condición',
  'Actions': 'Acciones',
  'How often will you be inspecting this equipment? We will use this to help forecast future inspections.': '¿Con qué frecuencia va a inspeccionar este equipo? Para calcular Prediciones futuras',
  'Hours per Day': 'Horas al día',
  'Inspection Planner': 'Planificador de inspección',
  'I will inspect every': 'Voy a inspeccionar cada',
  'On average how many days is this equipment in use, and on which days?': 'En promedio, ¿Cuántos días esta equipo en uso, y en qué días?',
  'Sat': 'Sab',
  'Mon': 'Lun',
  'Tue': 'Mar',
  'Wed': 'Mie',
  'Thu': 'Jue',
  'Fri': 'Vie',
  'New SMU/Hourmeter': 'Nuevo SMU/Horómetro',
  'What is the old SMU/Hourmeter meter reading?': '¿Cuál es la lectura previa de el SMU/Horómetro?',
  'What is the new meter SMU/Hourmeter reading?': '¿Cuál es la nueva lectura de el SMU/Horómetro?',
  'What is the date of the replacement?': '¿Cuál es la fecha de remplazo?',
  'Old SMU/Hourmeter Reading is required': 'Lectura Previa del SMU/Horómetro es necesaria',
  'Application': 'Aplicacion',
  'Ranking': 'Clasificación',
  'Machine Status': 'Estado de la máquina',
  'Please select the customer and job site where this equipment is located.': 'Por favor, seleccione el cliente y el sitio de trabajo en el que se encuentra el equipo.',
  'Create Equipment': 'Crear Equipo',
  'Would you like to setup a new equipment or modify an existing one?': '¿Le gustaría configurar un equipo nuevo o modificar uno existente?',
  'Modify Existing Equipment': 'Modificar el Equipo Existente',
  'How do you identify this equipment?': '¿Cómo identifica este equipo?',
  'What type of equipment is this?': '¿Qué tipo de equipo es este?',
  'What is the earliest known SMU/Hourmeter and the date of reading for this equipment?': '¿Cuál es la lectura más antigua conocida del contador (SMU) y la fecha de lectura para este equipo?',
  'You can attach a photo of this equipment which can be seen throughout the application.': 'Puede adjuntar una foto de este equipo que se puede ver en toda la aplicación.',
  'You can also set some aditional details, although this is not required.': 'También puede ajustar algunos detalles adicionales, aunque esto no es necesario.',
  'Select Customer & Job Site': 'Selecione un Cliente y Sitio de Trabajo',
  'Additional Information': 'Información Adicional',
  'Serial / Unit Number': 'Número de Serie / Unidad',
  'SMU/Hourmeter at Setup': 'SMU/Horómetro durante Instalación',
  'LTD at Setup': 'Vida del equipo (LTD) durante la Instalación',
  'Equipment Setup': 'Configuración del Equipo',
  'Setup Complete!': '¡Instalación completa!',
  'Now that you have setup your equipment, you need to setup the undercarriage for it before you can start recording inspections.': 'Ahora que ha configurado su equipo, es necesario configurar el tren de rodaje antes de poder empezar a registrar inspecciones.',
  'Setup Undercarriage for This Equipment': 'Configurar Carrileria para este Equipo',
  'Setup Another Equipment': 'Configurar otro Equipo',
  'Equipment is not selected!': 'El Equipo no está seleccionado!',
  'Chain & Frame Details': 'Detalles de Cadena y Marco',
  'Life(When installed on equipment)': 'Horas (Cuando se instaló en el equipo)',
  'SMU/HourMeter and Date validation passed!': 'Validacion SMU/Horómetro y fecha satisfactoria!',
  'Date(When installed on equipment)': 'Fecha (Cuando se instaló en el equipo)',
  'Equipment SMU/Hourmeter (at install)': 'SMU/Horómetro del Equipo (durante la instalación)',
  'Review and Save': 'Revisión y Guardar',
  'This will setup components on both sides of the undercarriage the same, you can view and edit sides indivdually if they are different': 'Esto instalara componentes en ambos lados de la carrileria, se puede ver y editar los lados individualmente si son diferentes',
  'Chain': 'Cadena',
  'Please add the components which will go on the chain.': 'Por favor, añadir los componentes que irán en la cadena.',
  'Grouser': 'Barras',
  'Please add the components which will go on the frame.': 'Por favor, añadir los componentes que irán en el marco.',
  'Cost': 'Costo',
  'Validation failed': 'Validación fallida',
  'Bushing': 'Juntas',
  'Budget Life': 'Vida Presupuestada',
  'Size': 'Tamaño',
  'Frame': 'Marco',
  'Idler': 'Rueda Guia',
  'Guard': 'Guarda',
  'Track Elongation': 'Alargamiento de Cadena',
  'Carrier Roller': 'Rodillo Superior',
  'Track Roller': 'Rodillo Inferior',
  'Hours at Install': 'Horas al Instalar',
  'Date at Install': 'Fecha al Instalar',
  'Equip. SMU/Hourmeter at install': 'SMU/Horómetro de Equipo durante la instalación',
  'Setup Undercarriage on Equipment': 'Configurar Carrileria en Equipo',
  'Hrs': 'Horas',
  'Submit': 'Enviar',
  'Unlock': 'Desbloquear',
  'Validation failed!': '¡Validación fallida!',
  'Hours at install': 'Horas a instalar',
  'By changing equipment you will lose all your inputs!': 'Al cambiar el equipo va a perder todos sus datos!',
  'Validation Passed.': 'Validación satisfactoria.',
  'Component attached to the system successfully!': 'Componente conectado al sistema satisfactoriamente!',
  'After you have submitted the data first time round, you are unable to setup components on both sides': 'Después de haber enviado los datos por primera vez, no podra instalar componentes en ambos lados',
  'The current evaluation of all the equipment you can view based on their last inspection. Filter this data down using the search above.': 'La evaluación actual de todo el equipo se puede ver en función de su última inspección. Filtrar estos datos usando la búsqueda arriba.',
  'Eval Overview': 'Clasificacion General',
  'Total count of undercarriage inspections performed on a month by month basis. Filter this data down using the search above.': 'Recuento total de inspecciones realizadas mes a mes. Filtrar estos datos usando la búsqueda arriba.',
  'JobSite is not selected!': 'Sitio de trabajo no está seleccionado!',
  'Create new system': 'Crear nuevo sistema',
  'Update existing': 'Actualizar existente',
  'Life(When cerated in inventory)': 'Vida/Horas (Cuando se creo en el inventario)',
  'Setup Undercarriage In Inventory': 'Configuración de Carrileria en Inventario',
  'Model is not selected!': 'Modelo no seleccionado!',
  'By changing selection you will lose all your inputs!': 'Al cambiar la selección, perderá todas sus datos!',
  'Setup new undercarriage': 'Configuración del nuevo tren de Rodaje',
  'Previous step validation failed!': 'Validación del paso anterior fallida!',
  'Warning': 'Advertencia',
  'Standard Link or Scallop Resistant Link': 'Cadena estándar o Resistente a deformacion de eslabon',
  'Please select the equipment.': 'Por favor, seleccione el equipo.',
  'You can only change the SMU/Hourmeter, LTD and Date of an existing equipment if there have been NO inspections performed, or actions recorded. If you need to record that a component has been changed, you should record an action against that equipment.': 'Sólo se puede cambiar el SMU/Horómetro, vida (LTD) y fecha de un equipo existente, si no ha habido inspecciones realizadas, o acciones registradas. Si necesita registrar un componente que se ha cambiado, debe registrar un accion contra dicho equipo.',
  'Examiner': 'Examinador',
  'Reset': 'Reiniciar',
  'Evaluation (Worst Side)': 'Evaluación (Peor Lado)',
  'A': 'A',
  'B': 'B',
  'C': 'C',
  'X': 'X',
  'Start Date': 'Fecha de Inicio',
  'End Date': 'Fecha final',
  'Single Flange': 'Pestana Sencilla',
  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  'Manage Inspection Types': 'Administrar tipos de Inspección',
  'Left Side': 'Lado izquierdo',
  'Language': 'Idioma',
  'Home Page': 'Página de inicio',
  'Currency': 'Moneda',
  'Unit of Measurement': 'Unidad de medida',
  'Determines how measurements are displayed to you when viewing inspection results, and how a components percentage worn is calculated when you enter a measurement. ': 'Determina cómo se muestraran las mediciones al visualizar los resultados de una inspección, y como el porcentaje de desgaste de componentes es calculado cuando se ingresa una medición.',
  'Determines how measurements are displayed to you when viewing inspection results, and how a components percentage worn is calculated when you enter a measurement. ,': 'Determina cómo se muestraran las mediciones al visualizar los resultados de una inspección, y como el porcentaje de desgaste de componentes es calculado cuando se ingresa una medición.',
  'Contact': 'Contacto',
  'Full Name': 'Nombre completo',
  'Phone Number': 'Número de teléfono',
  'Address': 'Dirección',
  'Street Address': 'Dirección',
  'Suburb / City': 'Suburbio / Ciudad',
  'Post Code': 'Código postal',
  'State': 'Estado',
  'Country': 'País',
  'Dashboard - Fleet Overview': 'Tablero - Flota general',
  'Millimetres (mm)': 'Milímetros (mm)',
  'Inches (inch)': 'Pulgadas (pulgadas)',
  'Email Address': 'Dirección de correo electrónico',
  'This is the email address that all emails, reports, etc. for your account will be sent to.': 'Esta es la dirección de correo electrónico donde correos, Reportes, etc., serán enviados.',
  'Username': 'Nombre de usuario',
  'This is what you use to sign in to both the web application and the mobile application.': 'Esto es lo que se utiliza para iniciar sesión en la aplicación web y la aplicación móvil.',
  'Change Your Password': 'Cambiar contraseña',
  'This is the password you use to sign in to both the web application and the mobile application to perform inspections on.': 'Esta es la contraseña que utiliza para iniciar sesión en la aplicación web y la aplicación móvil para realizar inspecciones.',
  'New Password': 'Nueva contraseña',
  'Repeat New Password': 'Repita la nueva contraseña',
  'Update Password': 'Actualizar contraseña',
  'Inspections Due Emails': 'Correos Inspecciones Pendientes',
  'Determines whether the sending of Inspections Due Emails is enabled or disabled. ': 'Determina si el envío de correos electrónicos Inspecciones pendientes es activo o no.',
  'Flange width is 5.24 in. (133 mm), New tread diameter is 30.16 in. (766 mm)': 'Brida anchura es de 5,24 pulg. (133 mm), Nueva diámetro banda de rodadura es 30,16 pulg. (766 mm)',
  'Flange width is 5.21 in. (132.4 mm), New Tread diameter is 29.54 in. (750.2 mm), UT Tool only to determine flange wear only': 'Brida anchura es de 5,21 pulg. (132,4 mm), diámetro de nueva banda de rodadura es 29,54 pulg. (750,2 mm), UT herramienta única para determinar brida desgaste solamente',
  'Measure across 3 teeth': 'Medida a través de 3 dientes',
  'Flange diameter is 12.28 in. (312 mm)': 'Diámetro de la brida 12,28 pulg. (312 mm)',
  'ForwardTravelHours': 'HoursHaciaAdelante',
  'ReverseTravelHours': 'HoursReversa',
  'ForwardTravelKms': 'KmsHaciaAdelante',
  'ReverseTravelKms': 'KmsReversa',
  'TrackSagLeft': 'TrackSagIzq',
  'TrackSagRight': 'TrackSagDer',
  'DryJointLeft': 'DryJointIzq',
  'DryJointRight': 'DryJointDer',
  'CannonExtLeft': 'CanonExtIzq',
  'CannonExtRight': 'CanonExtDer',
  'ScallopLeft': 'ScallopIzq',
  'ScallopRight': 'ScallopDer',
  'JobsiteNotes': 'NotesSitioTrabajo',
  'InspectionNotes': 'NotasInspection',
  'Dealer': 'Comerciante',
  'Projected': 'Proyectado',
  'Difference': 'Diferencia',
  'Low': 'Bajo',
  'High': 'Alto',
  'Medium': 'Medio',
  'Addition Observation Lists': 'Lista de Observaciones Adicionales',
  'Title': 'Título',
  'Image': 'Imagen',
  'Add Observations': 'Añadir Observaciones',
  'Select equipment to create new inspection': 'Seleccionar un equipo para nueva inspección',
  'Cancel': 'Cancelar',
  'Start Inspection': 'Iniciar Inspección',
  'Please check your user permissions, Only inspector or super user can create inspections': 'Por favor, revise sus permisos de usuario, solo inspectorer o super usuario puede crear inspecciones',
  'There is no audit history to display.': 'No hay historial de auditoría para mostrar.',
  'Send Report': 'Enviar reporte',
  'Include Quote': 'Incluir Cotizacion',
  'Event Time': 'Hora del evento',
  'Change': 'Cambio',
  'Select Email Recipients': 'Seleccione los destinatarios de correo electrónico',
  'Send': 'Enviar',
  'Add Recipient': 'Agregar destinatario',
  'An Observation Description is required': 'Una descripción de Observación es requida',
  'Adding Observation List': 'Añadiendo Lista de Observación',
  'Editing Observation List': 'Editando Lista de Observación',
  'Save Observation List': 'Guardar Lista de Observación',
  'Name': 'Nombre',
  'Background Colour': 'Color de Fondo',
  'Text Colour': 'Color de Texto',
  'Preview': 'Vista Previa',
  'Save': 'Guardar',
  'Select System / Component': 'Seleccione Sistema / Componente',
  'Action Informations': 'Informaciones de Acción',
  'Save Action': 'Guardar Acción',
  'Multiple Component Replacement': 'Reemplazar varios componentes',
  'Part Cost': 'Costo de Componente',
  'Labour Cost': 'Costo laboral',
  'MiscCost': 'Costos adicionales',
  'Note': 'Nota',
  'Current CMU': 'Horas de componente CMU actual',
  'There is no components on this system, please make sure your undercarriage setup correctly': 'No hay componentes en este sistema, por favor asegúrese de que la configuración de su tren de rodaje este correcta',
  'Setup new System': 'Configurar Sistema Nuevo',
  'Refresh Available Replacement List': 'Refrescar lista disponible de reemplazo',
  'There are no available replacements fits this component': 'No hay sustitutos disponibles para este componente',
  'Select Swap component': 'Seleccione el componente a remplazar',
  'Labour Cost Option': 'Opción de Costo Mano de Obra',
  'Misc Cost': 'Costos Adicionales',
  'Date of Action': 'Fecha de Acción',
  'Times Re-builded / Re-grousered/ Re-sealed': 'Veces Re-construido / Re-sellado',
  'Total Cost': 'Costo Total',
  'Customer hourly rate': 'Tarifa del Cliente por Hora ',
  'Uninstall this at SMU/Hourmeter': 'Desinstalar este SMU/Horómetro',
  'Action Against': 'Acción Contra',
  'Action Histories will be affected by this action': 'Historias de acción se verán afectados por esta acción',
  'Disable': 'Deshabilitar',
  'Enable': 'Habilitar',
  'Filter By Serial Number': 'Filtrar por número de serie',
  'CMU (Average)': 'CMU (Promedio)',
  'Part Number': 'Número de parte',
  'CMU (hrs)': 'CMU (horas)',
  '%Worn': '% Desgaste',
  'Action Date': 'Fecha de acción',
  'Latest Action': 'Ultima acción',
  'Latest Action Date': 'Fecha de última acción',
  'Action Taken': 'Acción tomada',
  'Date': 'Fecha',
  'DATE': 'FECHA',
  'History': 'História',
  'Relocate System': 'Reubicar Sistema',
  'System Notes': 'Notas del Sistema',
  'Update Notes': 'Actualizar Notas',
  'Relocate To Customer': 'Reubicar al cliente',
  'Relocate To Jobsite': 'Reubicar el sitio de trabajo',
  'Account': 'Cuenta',
  'General': 'General',
  'Alerts': 'Alertas',
  'Dashboard - Wear Rate Overview': 'Tablero - Vista de Desgaste',
  'Dashboard - Component Overview': 'Tablero - Vista de Componentes',
  'Hours': 'Horas',
  'Days': 'Dias',
  'Weeks': 'Semanas',
  'Months': 'Meses',
  'Delete': 'Eliminar',
  'Additional Observation Lists': 'Lista de observaciones adicionales',
  'Currently there is no observation list configured for this equipment': 'Actualmente no existe una lista de observación configuarada para este equipo',
  'You are currently missing the': 'Te hace falta',
  'Your Preferences': 'Preferencias',
  'Customer Name': 'Nombre del Cliente',
  'Add': 'Agregar',
  'Right Side': 'Lado Derecho',
  'Replace with new Chain and all components': 'Reemplazar con nueva cadena y todos sus componentes',
  'Replace with Chain from Inventory': 'Reemplazar con Cadena del inventario',
  'Repairs or Replacements of individual Chain Components': 'Reparacion o reemplazo de un componente de la cadena',
  'Replace with New Frame including new components': 'Reemplazar con nuevo bastidor y todos sus componentes',
  'Replace frame from Inventory': 'Reemplazar con Bastidor del inventario',
  'Repair or Replace individual Frame components': 'Reparacion o reemplazo de un componente del bastidor',
  'Replace Frame Components in Bulk': 'Reemplazar varios componentes del bastidor a la vez',
  'Update Jobsite': 'Actualizar Sitio de Trabajo',
  'Which jobsite would you like to move this equipment to?': '¿A qué lugar de trabajo le gustaría mover este equipo?',
  'SMU Reading is required': 'Lectura del Horómetro requerida',
  'New SMU must be greater than previous SMU': 'Nueva lectura del Horómetro debe ser mayor que la anterior',
  'New BCM must be greater than previous BCM': 'Nueva lectura del BCM debe ser mayor que la anterior',
  'New Tonnage must be greater than previous Tonnage': 'Nueva lectura de Tonelaje debe ser mayor que la anterior',
  'New SMU *': 'Lectura Actual del Horómetro',
  'Old SMU/Hourmeter *': 'Ultima lectura del Horómetro que se cambió',
  'New SMU/Hourmeter Reading is required': 'Nueva Lectura del Horómetro requerida',
  'Invalid date: Installation date is before equipment setup date!': 'Fecha Invalida: La fecha de insalacion de los componentes es antes de la fecha de instalacion del equipo ',
  'Equipment Setup Date:': 'Fecha de instalación del Equipo',
  'Invalid SMU/HourMeter Reading: SMU/HourMeter at install cannot be less than': 'Lectura del Horómetro invalida: La lectura no puede ser menor que',
  'Invalid SMU/HourMeter Reading: For the same date SMU/HourMeter has conflict': 'Lectura del Horómetro invalida: Para la misma fecha, la lectura del Horómetro no concuerda',
  'Invalid SMU/HourMeter: For': 'Lectura del Horómetro invalida: para',
  'SMU/HourMeter has conflict': 'La lectura del Horómetro no concuerda',
  'Something is loading please try again after loading completed!': 'Algo se esta cargando, por favor intenta nuevamente cuado este proceso haya terminado.',
  'You haven\'t recorded any repair costs yet.': 'No se ha registrado ningun costo de reparación',
  'Next Inspection Date SMU/Hourmeter': 'Proxima fecha de inspección y Horómetro',
  'Next Inspect Date/SMU': 'Próxima data de inspeção/SMU',
  'Graph': 'Grafica',
  'Overview': 'Vista General',
  'Right Side - Component Wear Graph and Forecast': 'Lado Derecho - Desgaste de Componentes, Grafica y Proyección',
  'Left Side - Component Wear Graph and Forecast': 'Lado Izquierdo - Desgaste de Componentes, Grafica y Proyección',
  'Last Inspection Date SMU/Hourmeter': 'Fecha y Horómetro de la última inspección',
  'New Thermography Inspection': 'Nueva Inspección Termográfica',
  'Overall Inspection Comment': 'Comentario General de Inspección',
  'Thermography Inspection': 'Inspección Termográfica',
  'Items per page': 'Items por página',
  'Description': 'Descripción',
  'Currently there is no observation list configured for this inspection and this equipment': 'Actualmente no hay una lista de observaciones configurada para esta inspección y este equipo',
  'Hours remaining until 100% worn': 'Horas restantes para 100% de desgaste',
  'There is no audit history to display': 'No Hay historia de auditoria registrada',
  'Error': 'Error',
  'Please release this quote report first': 'Por favor, primeiro libere esta cotización',
  'Add Job Site': 'Agregar Sitio de Trabajo',
  'Return to Undercarriage': 'Retornar a Carrileria',
  'Team Administration ': 'Grupo de Administracion',
  'A team can be considered either a customer or a dealership. Each team consists of it’s own group of users who have access to equipment within that team': 'Un grupo puede ser considerado un cliente o un concesionario. Cada grupo consiste de su propios usuarios los cuales tienen acceso a equipos dentro del grupo ',
  'Add User': 'Agregar Usuário',
  'Add Customer': 'Agregar Cliente',
  'Users': 'Usuários',
  'Customers': 'Clientes',
  'Dealerships': 'Concessionários',
  'Filter user table': 'Filtrar tabla de usuários',
  'Full Name ': 'Nombre Completo',
  'Team': 'Grupo',
  'Access': 'Tipo de Acesso',
  'More': 'Mas',
  'Request New Model': 'Solicitar Nuevo Modelo',
  'LTD is the “Life To Date” of the equipment': 'LTD es la “Vida a la fecha” del equipo.',
  'This will generally be the same as the SMU/Hour Meter reading': 'Generalmente es el mismo valor del Horometro',
  'If the meter has been changed, LTD shows the actual machine hours where the SMU/Hour Meter will only show the hours since the meter was installed.': 'Si el horometro ha sido cambiado, LTD muestra la vida del equipo mientras que SMU/Horómetro solo mostrara las horas desde que el horometro fue reemplazado.',
  'Date of Reading': 'Fecha de la lectura',
  'Undercarriage History ': 'Historia de Carrileria',
  'Select your Equipment ': 'Seleccione equipo',
  'Please Select': 'Por Favor Selecione',
  'System S/N': 'Nº de Série del Sistema',
  'Life Lived ': 'Vida Acumulada',
  'Life Remaining (100% Worn': 'Vida Restante (100% de desgaste)',
  'Projected Hours ': 'Horas Projetadas',
  'Both': 'Ambos',
  'Show All Parts': 'Mostrar Todas las Partes',
  'No action taken': 'Ninguna accion tomada',
  'Never': 'Nunca',
  'Sent': 'Enviado',
  'The PDF report has been emailed to all contacts successfully.': 'El Reporte en PDF ha sido enviado satisfactoriamente.',
  'Failed to send PDF report. System Error Cannot write the document to memory. Invalid Serial Number Version.': 'Error al enviar el Reporte PDF. El sistema no puede escribir el documento a la memoria. Version De numero de Serial invalido.',
  'Recommendations included in this quote ': 'Recomendaciones adicionadas a esta cotización',
  'Distance Unit': 'Unidad de Distancia',
  'Kilometers (km)': 'Kilometros (km)',
  'Miles (mi)': 'Millas (mi)',
  'Forward Travel': 'Distancia Recorrida Hacia Adelante',
  'Reverse Travel': 'Distancia Recorrida En Reversa',
  'Forward': 'Hacia Adelante',
  'Reverse': 'Reversa',
  'Create Thermography Inspection': 'Crear Inspección de Termografia',
  'Track Sag (mm)': 'Destemple de Cadena',
  'Pin Number': 'Numero de Pin',
  'Therm L/R': 'Termo Izq/Der',
  'Left Side Additional Component': 'Componente Adicional lado Izquierdo',
  'No Side Additional Component': 'Componente Adicional sin ladot',
  'Right Side Additional Component': 'Componente Adicional lado Derecho',
  'Sun': 'Dom',
  'You haven\'t set up any equipment yet.': 'No se ha creado ningun equipo.',
  'You don\'t have any inspection due for the selection.': 'No hay ninguna inspeccion pendiente para esta seleccion.',
  'There are no inspections to display.': 'No hay inspecciones para mostrar.',
  'General Inspections': 'Inspecciones Generales',
  'Thermography Inspections': 'Inspecciones de Termografia',
  'Both Inspections': 'Ambas Inspecciones',
  'Copy to All': 'Copiar a Todos',
  'Copy to Right': 'Copiar a la Derecha',
  'Done': 'Listo',
  'Update Equipment': 'Actualizar Equipo',
  'Undercarriage Inspection': 'Inspeccion de Carrileria',
  'Temperature Inspection': 'Inspeccion de Temperatura',
  'Severity': 'Severity',
  'Manage Custom Evaluation': 'Manejar Rangos de Evaluacion',
  'Set Evaluation Ranges': 'Configurar Rangos de Evaluacion',
  'Set Custom Evaluation Ranges': 'Configurar Rangos de Evaluacion',
  'Select Level': 'Seleccione Nivel',
  'Please select individual machine from the search field above.': 'Por favor seleccione un equipo para le busqueda ',
  'Equipment Level Selected': 'Nivel de Equipo Seleccionado',
  'Select Dealer': 'Seleccione Concesionario',
  'Select Jobsite': 'Seleccione Sitio de Trabajo',
  'A Range': 'Rango A',
  'B Range': 'Rango B',
  'C Range': 'Rango C',
  'X Range': 'Rango X',
  'Track Shoes': 'Zapatas',
  'Track Rollers': 'Rodillos Inferiores',
  'Tumblers': 'Tumblers',
  'Front Idlers': 'Rueda Guia Frente',
  'Rear Idlers': 'Rueda Guia Trasera',
  'Crawler Frame Guide': 'Guia Deslizador',
  'A machine with this Serial No and Unit No combination already exists in your Dealer Group. Please contact your Dealer group administrator to be given access to this machine': 'Esta combinación entre Numero serial y numero de unidad ya existe en otro Grupo de Concesionario. Por favor contacte al su administrador de Grupo de Concesionario para tener accesso a este equipo.',
  'Thermal Images': 'Imagenes Termicas',
  'UT Equivalent': 'UT equivalente',
  'Custom Evaluation ranges do not currently apply to Rope Shovels.': 'Custom Evaluation ranges do not currently apply to Rope Shovels.',
  'Additional Unit Number': 'Número de unidad adicional',
  'This equipment has 2 or more inspections': 'This equipment has 2 or more inspections',
  'Serial/Unit Search': 'Búsqueda de serie/unidad',
  'Recalculate & Save': 'Recalculate & Save',
  'UC Default Setup Type': 'peterminada informacion de la tren motriz',
  'Default Form Type': 'Forma predeterminado ',
  'Display Maintenance Inspection': 'Pantaya de Inspeccion de Mantenimiento ',
  'Advanced': 'Avanzado',
  'Basic': 'Básico',
  'Undercarriage ': 'Tren Motriz',
  'UC Dashboard': 'Pantaya de Carrilera',
  'Setup': 'Configuración',
  'New Inspections': 'Nuevas inspecciones',
  'Find Inspections': 'Encontrar inspecciones',
  'Component Performance': 'Rendimiento de los componentes',
  'Fleet Forecast': 'Planeacion de Flotilla',
  'Undercarriage Setup': 'Configuración del tren motriz',
  'Setup UC in Inventory': 'Configuración de inventario de tren motriz',
  'Search WRSE': 'Buscar WRSE',
  'New Workshop Repair': 'Nueva reparación de taller',
  'Field Inspections': 'Inspecciones de campo',
  'Search Digital Forms': 'Buscar formularios digitales',
  'Form Administration': 'Administración de formularios',
  'New Equipment': 'Equipo nuevo',
  'New Implement ': 'Implemento nuevo ',
  'Copy Implement ': 'Copiar implemento',
  'Modify Exisiting Implement ': 'Modificar implemento existente',
  'Training': 'entrenamiento ',
  'Help Centre': 'Seguridad',
  'Whats New': 'Centro de Ayuda',
  'Action History': 'Novedades',
  'Depth Guage': 'Historial de acción',
  'Jan': 'Calipers',
  'Feb': 'Enero',
  'Mar': 'Febrero',
  'Apr': 'Marzo',
  'May': 'Abril',
  'Jun': 'Mayo',
  'Jul': 'Junio',
  'Aug': 'Julio',
  'Sep': 'Agosto',
  'Oct': 'Septiembre',
  'Nov': 'Octubre',
  'Dec': 'Noviembre',
  'You haven\'t Recoreded any repair costs yet': 'Diciembre',
  'Manage Training': 'Gestionar la formación',
  'Search ': 'Buscar',
  'Setup ': 'Configuración',
  'Create Categories': 'Crear categorías',
  'Create Questions': 'Crear preguntas',
  'Load Slides': 'Cargar diapositivas',
  'Administrators - Webapp': 'Administradores - Webapp',
  'Administration Services': 'Servicios de administracion',
  'Managing Digital Form Inspections': 'Gestión de inspecciones de formularios digitales',
  'Implements and Structures': 'Implementos y estructuras',
  'Inspectors': 'Inspectores',
  'Installing the Mobile App': 'Instalación de la aplicación móvil',
  'Undercarriage Component Inspection Methods': 'Métodos de inspección de los componentes del tren de rodaje',
  'Dozer Inspections': 'Inspecciones de topadoras',
  'Rope Shovel Inspections': 'Inspecciones de pala de cuerda',
  'Daily Inspections': 'Inspecciones diarias',
  'Structual Inspections': 'Inspecciones estructurales',
  'Magnetic Plugs': 'Tapones Magnéticos',
  'Inerpreters': 'Intérpretes',
  'Interpreting Undercarriage Inspections - Webapp': 'Interpretación de las inspecciones del tren de rodaje - Webapp',
  'Supervisors': 'Supervisores',
  'Releasing Inspections': 'Liberación de inspecciones',
  'Team Admin, Access, and Permission': 'Administrador, acceso y permiso del equipo',
  'Managing Customers, Jobsites, and Users': 'Gestión de clientes, sitios de trabajo y usuarios',
  'Creating Digital Forms': 'Creación de formularios digitales',
  'Implements, Structures & Templates': 'Implementos, estructuras y plantillas',
  'Creating new Implements and Structures': 'Creación de nuevos implementos y estructuras',
  'Copying Implements & Structures': 'Copia de implementos y estructuras',
  'Modifying Implements & Structures': 'Modificación de implementos y estructuras',
  'Installing IOS App': 'Instalación de la aplicación IOS',
  'Installing Android App': 'Instalación de la aplicación de Android',
  'Installing Android App from Webapp': 'Instalación de la aplicación de Android desde Webapp',
  'Track Sag': 'Seguimiento de hundimiento',
  'Cannon Extension': 'Extensión de cañón',
  'Dry Joints Identification': 'Identificación de juntas secas',
  'Scalloping Measurement on a Link': 'Medición festoneada en un enlace',
  'Links': 'Enlaces',
  'Shoes': 'Zapatos',
  'Idlers': 'Ruedas locas',
  'Setup Equipment with Undercarriage - Web App': 'Configuración del equipo con tren de aterrizaje: aplicación web',
  'Setup Equipment with Undercarriage - Mobile App Offline': 'Configuración del equipo con tren de aterrizaje: aplicación móvil sin conexión',
  'Setup Equipment with Undercarriage - Mobile App': 'Equipo de instalación con tren de aterrizaje: aplicación móvil',
  'Load Machines onto Mobile App': 'Cargar máquinas en la aplicación móvil',
  'Perform an Inspection - Mobile App': 'Realizar una inspección: aplicación móvil',
  'Syncing and Exporting an Inspection - Mobile app': 'Sincronización y exportación de una inspección: aplicación móvil',
  'Creating New Equipment - Webapp': 'Creación de nuevos equipos - Webapp',
  'Chain and frame details - Webapp': 'Detalles de cadena y marco - Webapp',
  'Components - Webapp': 'Componentes - Webapp',
  'Load A Rope Shovel Onto iOS Device': 'Cargue una pala de cuerda en un dispositivo iOS',
  'Rope Shovel Inspection - Mobile App': 'Inspección de pala de cuerda: aplicación móvil',
  'Syncing and Exporting Inspections': 'Sincronización y exportación de inspecciones',
  'Loading a daily inspection form': 'Carga de un formulario de inspección diario',
  'Questions overview': 'Resumen de preguntas',
  'Simple answers and adding images': 'Respuestas sencillas y adición de imágenes',
  'Using flags and unanswered questions': 'Usar banderas y preguntas sin respuesta',
  'Exporting the form': 'Exportando el formulario',
  'Syncing, completing, and troubleshooting': 'Sincronizar, completar y solucionar problemas',
  'Loading a structural inspection form': 'Carga de un formulario de inspección estructural',
  'Syncing, completing and troubleshooting': 'Sincronizar, completar y solucionar problemas',
  'Loading a magnetic plug form': 'Carga de un formulario de enchufe magnético',
  'Question overview': 'Resumen de preguntas',
  'Using flags': 'Usando banderas',
  'What is Interpretation': '¿Qué es la interpretación?',
  'Opening the Interpretation Screen': 'Abrir la pantalla de interpretación',
  'Making Changes': 'Haciendo cambios',
  'Adding Recommendations': 'Agregar recomendaciones',
  'Adding Interpretation Comments': 'Adición de comentarios de interpretación',
  'Releasing the inspection': 'Liberando la inspección',
  'Rope Shovel Undercarriage Interpretation': 'Interpretación del tren de aterrizaje de la pala de cuerda',
  'Generating the Report': 'Generando el Informe',
  'No Undercarriage components setup': 'Sin configuración de componentes del tren de rodaje',
  'Enable Tracking by Distance Travelled': 'Habilitar seguimiento por distancia recorrida',
  'Equipment not in Use': 'Equipo no en uso',
  'Distance': 'Distancia',
  'Propel': 'Impulsar',
  'Propel %': 'Impulsar %',
  'Average Usage': 'Uso promedio',
  'Avg Usage': 'Uso promedio',
  'Residual Hours': 'Horas residuales',
  'Replacement Date': 'Fecha de reemplazo',
  'Work Order#': 'Orden de trabajo#',
  'Work Order': 'Orden de trabajo#',
  'B/Turn%': '% de giro de Bush',
  'Res. Life': 'Vida Residual',
  'Projected 100%': 'Proyectado 100%',
  'Projected 120%': 'Proyectado 120%',
  'Frame Condition': 'Condiciones del chasis',
  'Equipment DOE at Install': 'Distancia del equipo en el equipo en la instalación',
  'Distance Budget': 'Planificación de la distancia recorrida',
  'Frame Cost': 'Costo del chasis',
  'Frame Repair Cost': 'Costo de reparación del chasis',
  'Frame Configuration': 'Configuración del chasis',
  'Cannon Type': 'tipo de cañón',
  'Residual Life based on 100% budgeted hours/propel hours': 'Vida residual basada en el 100% de horas presupuestadas/horas de impulso',
  'Residual Life based on 120% budgeted hours/propel hours': 'Vida residual basada en el 120% de horas presupuestadas/horas de impulso',
  'Projected Life based on 100% budgeted hours/propel hours': 'Vida útil proyectada basada en el 100 % de horas presupuestadas/horas de impulso',
  'Projected Life based on 120% budgeted hours/propel hours': 'Vida útil proyectada basada en el 120 % de horas presupuestadas/horas de impulso',
  'Click to edit condition': 'Haga clic para editar la condición',
  'Click to edit': 'Haga clic para editar',
  'Click to edit Component': 'Haga clic para editar el componente',
  'UC Inspection': 'Inspección de la UC',
  'Maintenance Inspection': 'Inspección de mantenimiento',
  'End of Life Inspection': 'Inspección de fin de vida',
  'Last % Worn Forecasted': 'Último % de desgaste pronosticado',
  '% Worn Today': '% de desgaste hoy',
  'Distance Difference': 'Diferencia de distancia',
  '%Worn (heading)': '% de desgaste (encabezado)',
  'Inspection Type': 'Tipo de inspección',
  'AVG Daily Usage': 'Uso diario promedio',
  'Load More': 'Cargar más',
  'Worn Percentage': '% de desgaste',
  'Component Hours': 'Horas del componente',
  'Last Insp. % Worn': 'Última inspección % de desgaste',
  'Display Columns for': '¿Mostrar columnas por?',
  'Action Type': 'Tipo de acción',
  'Side': 'Lado',
  'Component Type': 'Tipo de componente',
  'REFRESH': 'REFRESCAR',
  'L/H Chain CMU': 'Horas acumuladas de los componentes del lado izquierdo',
  'R/H Chain CMU': 'Horas acumuladas de los componentes del lado derecho',
  'Action Desc': 'Descripción de la acción',
  'Entered By': 'Ingresado por',
  'Entered Date': 'Fecha de ingreso',
  'Total': 'Total',
  'TOTAL': 'Total',
  'Rolling': 'Rodante',
  'Stock Cost': 'Costo de inventario',
  'Rolling Stock Cost': 'Costo de inventario rodante',
  'Chain Cost': 'Costo de cadena',
  'Segment Cost': 'Costo de segmento',
  'Running Cost': 'Costo de operación',
  'Cost/Hour': 'Costo por hora',
  'Cost/Km': 'Costo por km',
  'Propel Hrs': 'Horas de impulso',
  'Reverse Dist. %': 'Porcentaje de reversión viajada',
  'Total Dist.': 'Distancia total',
  'Add Recommendation': 'Agregar recomendación',
  'Save Commment': 'Guardar comentario',
  'Duplicate Inspection': 'Inspección duplicada',
  'Refresh linked Inspection': 'Actualizar inspección vinculada',
  'Both Side': 'Ambos lados',
  'Forecast': 'Pronóstico',
  'Edit Component': 'Editar componente',
  'Add Component': 'Agregar componente',
  'Inspection Id': 'ID de inspección',
  'Enter text here...': 'Ingrese texto aquí...',
  'Quotes & Recommendations': 'Cotizaciones y recomendaciones',
  'Equaliser Bar Type': 'Tipo de barra de igualación',
  'Toe Out': 'Toe Out',
  'Straight': 'Recto',
  'Res. DOC': 'Distancia residual en el componente',
  'Edit Component Type': 'Editar tipo de componente',
  'Answer': 'Respuesta',
  'Hourmeter': 'Horómetro',
  'Select Type': 'Seleccionar tipo',
  'Select Status': 'Seleccionar estado',
  'Include Inventory on Equipment': 'Incluir inventario en el equipo',
  'Include Related Models': 'Incluir modelos relacionados',
  'Exclude "Scrap"': 'Excluir "Chatarra"',
  'Task List': 'Lista de tareas',
  'Chain to Inventory': 'Cadena al inventario',
  'Frame to inventory': 'Bastidor al inventario',
  'Idler to Inventory': 'Rueda loca al inventario',
  'Inventory Report': 'Reporte de inventario',
  'Serial#': 'Número de serie',
  'Equip unit #': 'Número de unidad del equipo',
  'Condition / Hour on Components / Action done': 'Condición / Horas en los componentes / Acción realizada',
  '%Link': '% de enlace',
  'Action': 'Acciones',
  '% Bush': '% de Bush',
  'Warning message': 'Mensaje de advertencia',
  'Images': 'Imágenes',
  'Initial cost': 'Costo inicial',
  'Repair cost': 'Costo de reparación',
  'Budget': 'Presupuesto',
  'Dist. Budget': 'Presupuesto de distancia',
  'Dist. Budget (Km)': 'Presupuesto de distancia',
  //Mohit
  //Translation done by mohit spanish
  'Choose a date': 'Elige una fecha',
  'Select Asset': 'Seleccionar activo',
  'Component Criticality': 'Criticidad del Componente',
  'Select Family': 'Seleccionar Familia',
  'Component List': 'Lista de Componentes',
  '% Contribution to UC Eval': '% Contribución a la Evaluación UC',
  'Fazer': 'Marca',
  'Data de Inspecção': 'Fecha de Inspección',
  'No Action': 'Sin Acción',
  'Certo': 'Derecho',
  'cadeia de série': 'Número de Cadena',
  'série do quadro': 'Número de Chasis',
  'Frame style': 'Estilo del Bastidor',
  'arbusto virado': 'Pasador y Buje Girado',
  'Unidade#': 'Nº de Unidad',
  'DG': 'Medidor de Profundidad',
  'R': 'Regla',
  'UK': 'Herramienta Desconocida',
  'Meter Unit Reading': 'Lectura del Horómetro',
  'Site de Trabalho': 'Lugar de Trabajo',
  'Measurement Point Description': 'Descripción del Punto de Medición',
  '% Contribution to Compart': '% Contribución a Compart',
  'Measurement Point List For': 'Lista de puntos de medición para',
  'User Contact': 'Contacto de Usuario',
  'Contains': 'Contiene',
  'Add New Customer': 'Agregar Nuevo Cliente',
  'User Contact Details': 'Detalles del Contacto de Usuario',
  'Customer Level': 'Nivel de Cliente',
  'Job Site Level': 'Nivel de Sitio de Trabajo',
  'Equipment Level': 'Nivel de Equipo',
  'Email': 'Correo Electrónico',
  'Health': 'Estado',
  'Under Carriage': 'Tren de Rodaje',
  'Service': 'Servicio',
  'Please Select a Customer': 'Por favor seleccione un cliente',
  'Update Selected': 'Actualizar Seleccionados',
  'Delete Selected': 'Eliminar Seleccionados',
  'Select Customer To Add': 'Seleccionar cliente para agregar',
  'Close': 'Cerrar',
  'Select Job Site(S) To Add': 'Seleccionar el/los Sitio(s) de Trabajo para Agregar',
  'Equipments': 'Equipos',
  'Select User To Add': 'Seleccionar usuario para agregar',
  'Select User(S) To Add': 'Seleccionar usuarios para agregar',
  'Add New User': 'Agregar nuevo usuario',
  'Reload': 'Recargar',
  'Export All': 'Exportar todo',
  'Customer Contact Details': 'Detalles del contacto del cliente',
  'Customer Contact': 'Contacto del Cliente',
  'Inspection Types': 'Tipos de Inspección',
  'Please select a model first': 'Por favor seleccione primero un modelo',
  'An Inspection Name is required': 'Se requiere un nombre de inspección',
  'Inspection': 'Inspección',
  'Manage': 'Administrar',
  'Inspection Name': 'Nombre de la inspección',
  'There is no inspection types configured for ': 'No hay tipos de inspección configurados para ',
  'Select Additional Observation Level': 'Seleccionar nivel de observación adicional',
  'Additional Observation Constraint Filter': 'Filtro de restricción de observación adicional',
  'Adding Additional Observation List': 'Agregando lista de observaciones adicionales',
  'Editing Additional Observation List': 'Editando lista de observaciones adicionales',
  'Select Answer Type': 'Seleccionar tipo de respuesta',
  'Additional Observation List On Customer': 'Lista de Observaciones Adicionales sobre el Cliente',
  'Add Dealership': 'Agregar Concesionario',
  'Add Dealer Group': 'Agregar Grupo de Concesionarios',
  'Job Sites': 'Sitios de Trabajo',
  'Dealer Group': 'Grupo de Concesionarios',
  'Undercarriage Inspections Due Emails': 'Correos electrónicos de inspecciones del tren de rodaje pendientes',
  'Daily Inspections Due Emails': 'Correos electrónicos de aviso de inspecciones diarias',
  'Alerting a user of any overdue Digital Inspections which have not been completed after 40 hours. ': 'Alerta al usuario sobre cualquier inspección digital vencida que no se haya completado después de 40 horas. ',
  'PIP Emails': 'Correos electrónicos PIP',
  'Receive email alerts for PIP’s  ': 'Recibir alertas por correo electrónico para PIPs ',
  'DFI Emails': 'Correos electrónicos DFI',
  'Receive email alerts for DFI’s  ': 'Recibir alertas por correo electrónico para DFIs ',
  'Leave Approval Emails': 'Correos electrónicos de aprobación de permisos',
  'NSW': 'NSW',
  'WA': 'WA',
  'Alerts on the Dashboards': 'Alertas en los Paneles',
  'When the box is ticked the alerts will show. ': 'Cuando la casilla esté marcada, se mostrarán las alertas. ',
  'User Preferences': 'Preferencias del Usuario',
  'Undercarriage User Type': 'Tipo de Usuario del Tren de Rodaje',
  'UC Dashboard Settings': 'Configuración del Panel UC',
  'UC Component Inspection Order': 'Orden de Inspección de Componentes UC',
  'UC Multiple Measurements': 'Múltiples Mediciones UC',
  'UC Equipment Conditions': 'Condiciones del Equipo UC',
  'UC Inspection & Jobsite Comments Display': 'Pantalla de Comentarios de Inspección UC y Sitio de Trabajo',
  'Undercarriage Forecast - % Worn Today': 'Pronóstico del Tren de Rodaje - % de Desgaste Hoy',
  'GET Dashboard Tasks Show/Hide': 'Mostrar/Ocultar Tareas del Panel GET',
  'Enable Replace Existing tab': 'Habilitar pestaña Reemplazar existente',
  'UC Equipment Detail Settings': 'Configuración de Detalles del Equipo UC',
  'Please refresh the page to see this change': 'Por favor actualice la página para ver este cambio',
  //
  //Aditya
  'Forecast Selection': 'Selección de Pronóstico',
  'Preset Forecast Wear Rates': 'Tasas de desgaste previstas preestablecidas',
  'Usage (Hrs)': 'Uso (Horas)',
  'Latest SMU/DOE': 'Último SMU/DOE',
  'Average From Last 3 Inspections': 'Promedio de las últimas 3 inspecciones',
  'Show dates for 100% Worn': 'Mostrar fechas para 100% de desgaste',
  'Preset Averages': 'Promedios preestablecidos',
  'Safety Factor': 'Factor de Seguridad',
  'Show dates for 120% Worn': 'Mostrar fechas para 120% de desgaste',
  'Winter': 'Invierno',
  'Summer': 'Verano',
  'SMU:': 'SMU:',
  'Shoulder': 'Hombro',
  'Other': 'Otro',
  'Model Level': 'Nivel del Modelo',
  'Machine Level': 'Nivel de la Máquina',
  'Last 4th Historical Inspection': '4ª Última Inspección Histórica',
  'DOE:': 'DOE:',
  'Forecast-Settings': 'Configuración de Previsión',
  'Forecast Method': 'Método de Previsión',
  'Forecast Future Service': 'Previsión de Servicio Futuro',
  'Next PM Service': 'Próximo Servicio PM',
  '2nd PM Service': '2º Servicio PM',
  'Floating Date': 'Fecha Flotante',
  'Floating Date 2': 'Fecha Flotante 2',
  'None': 'Ninguno',
  'Latest SMU': 'Último SMU',
  'Save/Refresh': 'Guardar/Actualizar',
  'Prior Inspect 3': 'Inspección Anterior 3',
  'Prior Inspect 2': 'Inspección Anterior 2',
  'Prior Inspect 1': 'Inspección Anterior 1',
  'Last Inspect': 'Última Inspección',
  'Avg CMU': 'Promedio CMU',
  'Per % Wear': 'Por % de Desgaste',
  'Avg DOC': 'Promedio DOC',
  'Date 100% Worn': 'Fecha 100% de Desgaste',
  'Date 120% Worn': 'Fecha 120% de Desgaste',
  'Last Inspection': 'Última Inspección',
  'Show Last 4th Historical Inspection': 'Mostrar la 4ª Última Inspección Histórica',
  'Planner': 'Planificador',
  //
  'Fleet Reporting': 'Informe de la Flota',
  'Pre and Post Hire Report': 'Informe de Evolución Previa y Posterior a la Instalación',
  'Email Log': 'Registro de correo electrónico',
  'Advances Forecasting': 'Proyecciones Avanzadas',
  'Inspection Data Export': 'Exportación de Datos de Inspección',
  'Report Selection': 'Seleccionar Informe',
  'Inspected machines': 'Equipos Inspeccionados',
  'Identified Issues': 'Identificación de Problemas',
  'Track Tensions': 'Tensión de la Oruga',
  'Undercarriage Configuration': 'Configuración del Tren de Rodaje',
  'Dealer Name': 'Nombre del Concesionario',
  'Filter by Component Details': 'Filtrar por Detalles de Componentes',
  'Jobsite Type': 'Tipo de Sitio de Trabajo',
  'Only components currently fitted to equipment': 'Solo los componentes instalados en el equipo.',
  'Export to Excel': 'Exportar a Excel',
  'Component Performance Details': 'Detalles del Rendimiento del Componente',
  'Averages': 'Promedio',
  'Part': 'Pieza',
  'Last Worn': 'Último Desgaste',
  'Last Eval': 'Última Evaluación',
  'Projected 100% Hrs': 'Vida Proyectada al 100%',
  'Projected 120% Hrs': 'Vida Proyectada al 120%',
  'Date Removed': 'Fecha de Retiro',
  'Cost Per Hour': 'Costo por Hora',
  'AVG': 'Promedio',
  'Start date': 'Fecha de Inicio',
  'Interval': 'Intervalo',
  'Serial No./ Unit No.': 'N.º de Serie/N.º de Unidad',
  'Totals Only': 'Solo Totales',
  'Totals & Details': 'Totales y Detalles',
  'OEM Part#': 'Número de Pieza OEM',
  'MFR Part#': 'Número de Pieza del Fabricante',
  'Select equipment': 'Seleccionar Equipo',
  'Meter reading': 'Lectura del Horómetro',
  'Life to Date': 'Vida Acumulada del Equipo',
  'Setup date': 'Fecha de Configuración',
  'Download report': 'Descargar Informe',
  'Add Inspection and Comments': 'Agregar Inspecciones y Comentarios',
  'log sent': 'Registro enviado',
  'Report Number': 'Número del Informe',
  'Perform Search': 'Buscar',
  'Report No': 'N.º del Informe',
  'Log Date': 'Fecha de Registro',
  'Sent to Address': 'Enviar a la Dirección de Correo',
  'Selection Criteria for Filtering': 'Criterios de Selección para Filtrar',
  'Select Brand': 'Seleccionar Marca',
  'Select Year': 'Seleccionar Año',
  'Select Month': 'Seleccionar Mes',
  'Show and hide columns': 'Mostrar y Ocultar Columnas',
  'Saved Scenarios for Forecasting': 'Escenarios Guardados para Proyecciones',
  'Segments': 'Segmentos de la Rueda Motriz',
  'Averages for selected data': 'Promedios para los Datos Seleccionados',
  'Scenario': 'Escenarios',
  'Update selection': 'Actualizar Selección',
  'export': 'Exportar',
  'Machine Inspection Data': 'Información de Inspección del Equipo',
  'Average Daily Hrs': 'Promedio de Horas Diarias',
  'Average Daily Dist': 'Promedio de Distancia Diaria',
  'Inspection Events': 'Eventos de Inspección',
  'Risk Rating': 'Clasificación de Riesgo',
  'Inspection Comments': 'Comentarios de la Inspección',
  'Recommended Actions': 'Acciones Recomendadas',
  'Your Inspection ID': 'ID de la Inspección',
  'Measured Data Part Wear % per Component': 'Desgaste Medido del Componente (%)',
  'Bush Turned Left': 'Buje Girado Izquierdo',
  'Bush Turned Right': 'Buje Girado Derecho',
  'Additional unit number': 'Número Adicional',
  'BCM at setup': 'BCM en la Configuración',
  'Tonnage at setup': 'Tonelaje en la Configuración',
  'Choose file': 'Seleccionar Archivo',
  'No file chosen': 'Ningún Archivo Seleccionado',
  'Usage Distance (km) per day': 'Distancia de Uso (km) por Día',
  'How often will you be inspecting this equipment?': '¿Con qué frecuencia inspeccionará este equipo?',
  'You can also set some additional details': 'Puede agregar información adicional, aunque no es obligatorio.',
  'Date at install (chain)': 'Fecha de Instalación (Cadena)',
  'SMU on Equipment at Install': 'Horas SMU al Instalar',
  'Historical Hours on Chain at Install': 'Horas Acumuladas de la Cadena desde la Instalación',
  'Date at Install (Frame)': 'Fecha de Instalación (Chasis)',
  'Budget life(Hrs)': 'Vida Planificada (Horas)',
  'Budget Distance(Km)': 'Distancia Planificada (km)',
  'Historical Hours on Frame at Install': 'Horas Acumuladas del Chasis desde la Instalación',
  'Date of Setup': 'Fecha de Configuración',
  'Historical Hours on Chain at Setup': 'Horas Históricas de la Cadena en la Configuración',
  'Historical Distance on Chain at Setup': 'Distancia Histórica de la Cadena en la Configuración',
  'Chain Components': 'Componentes de la Cadena',
  'Show Parts Ids': 'Mostrar Códigos de Piezas',
  'Job': 'Trabajo',
  'Cleaner Holes': 'Agujeros de Limpieza',
  'UnKnown': 'Desconocido',
  'Disabled': 'Desactivado',
  'Edit Observation': 'Editar Observación',
  'Update Equipment Status': 'Actualizar Estado del Equipo',
  'Select Equipment Status': 'Seleccionar Estado del Equipo',
  'Update': 'Actualizar',
  'Search WSRE': 'Buscar Taller de Reparación',
  'Job Status': 'Estado del Trabajo',
  'Temperature Inspections': 'Inspección de Temperatura',
  'CRACK VIEW': 'Vista de Grietas',
  'Search Results': 'Resultados de Búsqueda',
  '# of Cracks': 'Número de Grietas',
  'Total Crack Length': 'Longitud Total de Grietas',
  'Average Crack Length': 'Longitud Promedio de Grietas',
  'Fixed': 'Reparado',
  'Hide Favorites': 'Ocultar Favoritos',
  'Create Favorite': 'Crear Favorito',
  'Select family': 'Seleccionar Familia',
  'Select asset Make': 'Seleccionar Marca del Activo',
  'Select Job site': 'Seleccionar Sitio de Trabajo',
  'Select Male': 'Seleccionar Marca',
  'Select Component Type': 'Seleccionar Tipo de Componente',
  'Select Asset Type': 'Seleccionar Tipo de Activo',
  'Asset Serial Number': 'Número de Serie del Activo',
  'Select Asset Definition': 'Seleccionar Definición del Activo',
  'Select Serial Number': 'Seleccionar Número de Serie',
  'Select Alt. Number': 'Seleccionar Número Alternativo',
  'Template': 'Plantilla',
  'All': 'Todo',
  'Rest': 'Limpiar',
  'Serch': 'Buscar',
  'Asset View': 'Vista del Activo',
  'Asset Location History': 'Historial de Ubicación del Activo',
  'Crack View': 'Vista de Grietas',
  'Asset definition': 'Definición del Activo',
  'Alt. Serial': 'Número Alternativo',
  'Imp. Serial': 'Número de Serie Imp.',
  'Life': 'Vida',
  'Residual': 'Residual',
  'Total Life': 'Vida Total',
  'Replace Date': 'Fecha de Reemplazo',
  'Warranty Status': 'Estado de Garantía',
  'Build No': 'Número de Construcción',
  'Next Inspect': 'Próxima Inspección',
  'Flag': 'Marcador',
  'Please select the customer and job site': 'Seleccione el Cliente y el Sitio de Trabajo',
  'What is the earliest known SMU': '¿Cuál es la SMU más antigua conocida?',
  'BCM at Setup': 'BCM en la Configuración',
  'Tonnage at Setup': 'Tonelaje en la Configuración',
  'Tons': 'Toneladas',
  'Choose files': 'Seleccionar Archivos',
  'No Files Chosen': 'Ningún Archivo Seleccionado',
  'Hours of Use': 'Horas de Uso',
  'Per Day': 'Por Día',
  'Tues': 'Mar',
  'Thurs': 'Jue',
  'Advanced Forecasting': 'Proyecciones Avanzadas',
  'Now that you have setup your equipment': 'Ahora que ha configurado su equipo, debe configurar los implementos antes de registrar inspecciones.',
  'Setup Implements for This Equipment': 'Configurar Implementos para este Equipo',
  'New Implement': 'Nuevo Implemento',
  'Customer and Jobsite Selection': 'Selección de Cliente y Sitio de Trabajo',
  'Add to Equipment': 'Agregar al Equipo',
  'Jobsite Inventory': 'Inventario del Sitio',
  'Equipment SMU at initial Install': 'SMU del Equipo en la Instalación Inicial',
  'Implement Definition': 'Definición del Implemento',
  'Select Asset Model': 'Seleccionar Modelo del Activo',
  'Implement Capacity': 'Capacidad del Implemento',
  'Select GET Type': 'Seleccionar Tipo de GET',
  'Implement Details': 'Detalles del Implemento',
  'Implement Serial Number': 'Número de Serie del Implemento',
  'Additional Serial #': 'Número de Serie Adicional',
  'Implement make': 'Marca del Implemento',
  'Implement Budget': 'Presupuesto del Implemento',
  'Implement Tons at setup': 'Tonelaje del Implemento en la Configuración',
  'Implement Setup Date and Hours': 'Fecha y Horas de Configuración del Implemento',
  'Hours on Implement at setup': 'Horas del Implemento en la Configuración',
  'Implement Cost': 'Costo del Implemento',
  'Implement Purchased Cost': 'Costo de Compra del Implemento',
  'Save changes & Go To next': 'Guardar Cambios y Continuar',
  'Add implement Image': 'Agregar Imagen del Implemento',
  'Advanced Implement Copying': 'Copia Avanzada de Implementos',
  'Source Details': 'Detalles de Origen',
  'Please select the customer and job site where the EXISTING implement is located': 'Seleccione el Cliente y el Sitio donde se encuentra el Implemento EXISTENTE',
  'Is the EXISTING implement on an equipment, or in inventory ?': '¿El implemento EXISTENTE está en un equipo o en inventario?',
  'Destination Details': 'Detalles de Destino',
  'Please select the customer and job site where the DESTINATION implement is located': 'Seleccione el Cliente y el Sitio donde estará ubicado el Implemento DESTINO',
  'Is the DESTINATION implement on an equipment, in inventory or exisiting implement?': '¿El implemento DESTINO está en un equipo, inventario o implemento existente?',
  'Select Implement(s) to be copied': 'Seleccionar Implemento(s) a Copiar',
  'Select Implement': 'Seleccionar Implemento',
  'Imp Type:Serial': 'Tipo Imp : Serie',
  'Implement Type': 'Tipo de Implemento',
  'New Serial No.': 'Nuevo N.º de Serie',
  'Equipment SMU at Setup': 'SMU del Equipo al Configurar',
  'Budget Hours': 'Horas de Presupuesto',
  'Purchased Cost': 'Costo de Compra',
  'Copied': 'Copiado',
  'Copy Selected': 'Copiar Seleccionados',
  'Modify Asset': 'Modificar Activo',
  'Add Implement Image': 'Agregar Imagen del Implemento',
  'Asset Definition Setup': 'Configuración de Definición del Activo',
  'Input Asset Definition': 'Ingresar Definición del Activo',
  'Input Model #': 'Ingresar Modelo #',
  //'Reset': 'Limpiar',
  //'Add New': 'Agregar Nuevo',
  'Asset/System Type': 'Tipo de Sistema/Activo',
  'Asset Definition': 'Definición del Activo',
  'Model #': 'N.º de Modelo',
  'PDF Formats to be used': 'Formatos PDF a utilizar',
  'Manage Observation Lists': 'Administrar Listas de Observaciones',
  'Select a Customer': 'Seleccionar Cliente',
  'Serial/ Unit Search': 'Buscar por Nº de equipo/serie',
  'Stautus': 'Estado',
  'Off-Highway': 'Fuera de carretera',
  'Tempreture Inspections': 'Inspección de temperatura',
  'UC planner': 'Planificador del tren de rodaje',
  'Display options': 'Opciones de visualización',
  'Coloums': 'Columnas',
  'Dates': 'Fechas',
  'Legend': 'Leyenda',
  'tasks': 'Tareas',
  'Enter SMU/dates': 'Ingresar SMU/Fecha',
  'Create favorite Generate': 'Crear favorito / Generar',
  'February': 'Febrero',
  'Enter Date for SMU': 'Ingresar fecha para SMU',
  'Favorite': 'Favorito',
  'Last Known': 'Última lectura conocida del SMU o distancia',
  'Enter Date': 'Ingresar fecha',
  'Enter SMU': 'Ingresar SMU',
  'Equipment Serial No/Unit No': 'Nº de serie o unidad del equipo',
  'Select All': 'Seleccionar todo',
  'Recommended Action': 'Acción recomendada',
  'Oldest Date': 'Fecha más antigua',
  'Highest Severity': 'Mayor severidad',
  'Earliest': 'Lectura de SMU más antigua',
  'Hours Gained': 'Horas ganadas después de la acción',
  'Adjust all staus for equipment': 'Ajustar todos los estados del equipo',
  'Adjust all status for Equip': 'Ajustar todos los estados del equipo',
  'Action Search': 'Búsqueda de Acción',
  'Favorites': 'Favoritos', 'Download': 'Descargar',
  'SMU & PMU Service': 'Servicio SMU & PMU',
  'No data available': 'No hay datos disponibles',
  'The data will be cleared, are you sure': 'Los datos se borrarán, ¿está seguro?',
  'Search O/S UC Action Recommendations': 'Buscar Recomendaciones de Acción O/S UC',
  'Equipment Serial No/UnitNo': 'N.º de Serie del Equipo/N.º de Unidad',
  'Action Recommendation date is a future Date, which is not permissible in the Action Taken Screen, the system will use the current Date and Hour meter, please adjust accordingly': 'La fecha de recomendación de la acción es una fecha futura, lo cual no está permitido en la pantalla de Acción Realizada. El sistema utilizará la fecha actual y el medidor de horas, por favor ajústelo en consecuencia.',
  'Summary': 'Resumen',
  'Continue': 'Continuar',
  'Hide Favourites': 'Ocultar Favoritos',
  'Please use the Search field above to select what equipment you are shown.': 'Por favor, use el campo de búsqueda de arriba para seleccionar qué equipo desea ver.',
  'Asset Alt. Number': 'Número Alternativo del Activo',
  'EQUIPMENT VIEW': 'VISTA DEL EQUIPO',
  'ASSET VIEW': 'VISTA DEL ACTIVO',
  'ASSET LOCATION HISTORY': 'HISTORIAL DE UBICACIÓN DEL ACTIVO',
  'Alt.Serial': 'Serie Alternativa',
  'Job #': 'N.º de Trabajo',
  'Select Side': 'Seleccionar lado',
  'Select Unit Number': 'Seleccionar número de unidad',
  'Unit No': 'Número de unidad',
  'Average Projected to 100%': 'Promedio proyectado al 100%',
  'Average Projected to 120%': 'Promedio proyectado al 120%',
  'Average Cost per Hour': 'Costo promedio por hora',
  'Manually Schedule Next Inspection': 'Programar manualmente la próxima inspección',
  'Advance Forecast Settings': 'Configuración de pronóstico avanzado',
  'Display Settings- Current Forecast Status & Safety Margin': 'Configuración de visualización - Estado de pronóstico actual y margen de seguridad',
  'Add Safety': 'Agregar margen de seguridad',
  'Save & Update': 'Guardar y actualizar',
  'Distance Ratio': 'Ratio de distancia',
  'Usage Distance': 'Distancia de Uso',
  'per day': 'por Día',
  "SMU Last Known Date": "Fecha de la Última SMU Conocida",
  "SMU Last Known SMU": "Última SMU Conocida",
  "Distance Forward": "Distancia Hacia Adelante",
  "Distance Reverse": "Distancia Hacia Atrás",
  "Last Dist. Total": "Última Distancia Total",
  "Last Known Dist. Date": "Fecha de la Última Distancia Conocida",
  "Forward Distance": "Distancia Hacia Adelante",
  "Reverse Distance": "Distancia Hacia Atrás",
  "Total Distance": "Distancia Total",
  "Close PM's": "Cerrar PMs",
  "Next Pm Service": "Próximo Servicio PM",
  "2nd Pm Service": "Segundo Servicio PM",
  "Floating Date 1": "Fecha Flotante 1",
  "Tools & Actions": "Herramientas y Acciones",
  "Display Options": "Opciones de Visualización",
  "Enter SMU/Dates": "Ingresar SMU/Fechas",
  "Last Inspect. Worn %": "% de Desgaste en la Última Inspección",
  "% Worn <br>Today": "% de Desgaste <br>Hoy",
  "Floating Pm1 Service": "Servicio PM Flotante 1",
  "Floating Pm2 Service": "Servicio PM Flotante 2",
  "100 % Worn": "100 % Desgastado",
  "120 % Worn": "120 % Desgastado",
  "Start Time": "Hora de Inicio",
  "Log Sent": "Registro Enviado",
  "Not Sent": "No Enviado",
  "Lab Number": "Número de Laboratorio",
  "Sent To Address": "Enviado a la Dirección",
  "Please use the Search field above to select what Email Log you are shown.":
    "Use el campo de búsqueda de arriba para seleccionar qué registro de correo electrónico desea ver.",
  "Next Pm Service Header": "Próximo \nServicio PM",
  "2nd Pm Service Header": "2º \nServicio PM",
  "Floating Pm1 Service Header": "Servicio PM \nFlotante 1",
  "Floating Pm2 Service Header": "Servicio PM \nFlotante 2",
  "100 % Worn Header": "100 % \nDesgastado",
  "120 % Worn Header": "120 % \nDesgastado",
  "Last Inspect. Worn % Header": "% de Desgaste\n en la Última\n Inspección",
  "Generate": "Generar",
  'Last Known Dist. Date Header': "Fecha de la \nÚltima Distancia Conocida",
  'SMU Last Known Date Header': 'Fecha de la\n Última SMU Conocida',
  'SMU Last Known SMU Header': 'Último \nSMU Conocido',
  'Distance Forward Header': 'Distancia \nhacia Adelante',
  'Distance Reverse Header': 'Distancia \nen Reversa',
  'Last Dist. Total Header': 'Total de la\n Última Distancia',
  'Forward Distance Header': 'Distancia \nhacia Adelante',
  'Reverse Distance Header': 'Distancia\n en Reversa',
  'UNDERCARRIAGE': 'TREN DE RODAJE',
  'Alert Name': 'Nombre de la Alerta',
  'Frequency': 'Frecuencia',
  'Enabled': 'Habilitado',
  'Email Enabled': 'Correo Electrónico Habilitado',
  'Percentage Worn': 'Porcentaje de Desgaste',
  "Digital Inspections": "Inspecciones Digitales",
  "Field Inspection Dashboard": "Panel de Inspección de Campo",
  "Get & Wear Surfaces": "GET y Superficies de Desgaste",
  "GET Inspections": "Inspecciones GET",
  "New GET Inspection": "Nueva Inspección GET",
  "Asset Model Setup": "Configuración del Modelo de Activo",
  "Document Library": "Biblioteca de Documentos",
  "PIP Setup": "Configuración PIP",
  "Warranty Tracking": "Seguimiento de Garantía",
  "Observation List Setup": "Configuración de Lista de Observación",
  "CRC Dashboard": "Panel CRC",
  "Undercarriage": "Tren de Rodaje",
  "Setup Additional Components": "Configurar Componentes Adicionales",
  "Safety": "Seguridad",
  "Dashboards": "Paneles",
  "Inductions": "Inducciones",
  "Other Inspections": "Otras Inspecciones",
  "Policies and Procedures": "Políticas y Procedimientos",
  "Leave": "Permiso",
  "HOME - Admin Access": "INICIO - Acceso Admin",
  "Safety Dashboard": "Panel de Seguridad",
  "General Dashboard": "Panel General",
  "Safety Indicators": "Indicadores de Seguridad",
  "- View/Edit Monthly Hours": "Ver/Editar Horas Mensuales",
  "- Add Monthly Dashboard Message": "Agregar Mensaje Mensual al Panel",
  "- Add Toolbox Talk": "Agregar Toolbox Talk",
  "- Add Take 5s": "Agregar Take 5",
  "- Setup Forms": "Configurar Formularios",
  "Upload Completed Paper Form": "Subir Formulario en Papel Completado",
  "Training Register": "Registro de Capacitación",
  "Search & Review Forms": "Buscar y Revisar Formularios",
  "Select Form": "Seleccionar Formulario",
  "Enter Safety Observation": "Ingresar Observación de Seguridad",
  "Search Safety Observations": "Buscar Observaciones de Seguridad",
  "- Setup Departments/Work Areas": "Configurar Departamentos/Áreas de Trabajo",
  "- Setup Users": "Configurar Usuarios",
  "- Setup Incident Types": "Configurar Tipos de Incidente",
  "- Setup Safety Questions": "Configurar Preguntas de Seguridad",
  "Perform Induction": "Realizar Inducción",
  "Search Induction": "Buscar Inducción",
  "- Setup Induction Types & Sections": "Configurar Tipos y Secciones de Inducción",
  "- Setup Induction Slides": "Configurar Diapositivas de Inducción",
  "- Setup Induction Questions": "Configurar Preguntas de Inducción",
  "Leave Admin": "Administración de Permisos",
  'GET Dashboard': 'Panel GET',
  'TTadmin': 'Administrador TT',
  "Action Description & Comment": "Descripción de la Acción y Comentario",
  "Old Value": "Valor Anterior",
  "New Value": "Nuevo Valor",
  "Modified By": "Modificado Por",
  "Audit Trail": "Registro de Auditoría",
  "Screen": "Pantalla",
  'Copy Implement Advanced': 'Copiar Implementar Avanzado',
  'Cast': 'Reparto',
  'Unit #': 'Unidad #',
  "Number of Observations": "Número de Observaciones",
  "Components Currently Using": "Componentes Actualmente en Uso",
  "Crack Obs. List": "Lista de Observaciones de Grietas",
  "Crack Severity List": "Lista de Severidad de Grietas",
  "Active": "Activo",
  "Setup New List": "Configurar Nueva Lista",
  "List Name": "Nombre de la Lista",
  "General Bucket Observations": "Observaciones Generales del Balde",
  "Add Observation": "Agregar Observación",
  "Enter Observation and Press Add": "Ingrese la Observación y Presione Agregar",
  "Observation List": "Lista de Observaciones",
  "Edit Observation List": "Editar Lista de Observaciones",
  "Add/Update": "Agregar/Actualizar",
  "Observaton": "Observación",
  "There are no observation lists created for this customer. Click Add New to create one.": "No hay listas de observaciones creadas para este cliente. Haga clic en Agregar Nuevo para crear una.",
  "Existing Implement": "Implemento Existente",
  "Implement": "Implemento",
  "Selecting Copying of Schematics for Asset": "Seleccionar Copia de Esquemas para el Activo",
  "Reference Schematics to Originating Templates": "Referenciar Esquemas a las Plantillas de Origen",
  "Specific Assets": "Activos Específicos",
  "The Source Implement is not listed as fitting the Model of the Equipment you have selected,": "El implemento de origen no está listado como compatible con el modelo del equipo seleccionado,",
  "however if you wish to proceed it will be added.": "sin embargo, si desea continuar se agregará.",
  "Implement Hours at Setup": "Horas del Implemento en Configuración",
  "Implement Serial": "Serie del Implemento",
  "Select Component": "Seleccionar Componente",
  "Component Name": "Nombre del Componente",
  "Part No": "Nº de Parte",
  "Select Obs. Point": "Seleccionar Punto de Observación",
  "Observation Point": "Punto de Observación",
  "OP Type": "Tipo de OP",
  "Update Image": "Actualizar Imagen",
  "Delete Image": "Eliminar Imagen",
  "Fabricated": "Fabricado",
  "Meter Read / SMU": "Lectura del Medidor / SMU",
  "JSON": "JSON",
  "CSV Export": "Exportar CSV",
  "No Data Found - please can reset your selection and try again.": "No se encontraron datos - por favor, restablezca su selección e inténtelo de nuevo.",
  "Start SMU": "SMU Inicial",
  "End SMU": "SMU Final",
  "Start CMU": "CMU Inicial",
  "End CMU": "CMU Final",
  "Start Dist": "Distancia Inicial",
  "End Dist": "Distancia Final",
  "Update Selection": "Actualizar Selección",
  "On-Hire Inspection": "Inspección de Entrada",
  "Off-Hire Inspection": "Inspección de Salida",
  "Left % Used": "% Usado Izquierda",
  "Right % used": "% Usado Derecha",
  "Original Cost": "Costo Original",
  "Leave a comment": "Dejar un comentario",
  "GET Inspection": "Inspección GET",
  "Get Implement": "Obtener Implemento",
  "Digital Forms": "Formularios Digitales",
  "Equipment SMU at Initial Install": "SMU del Equipo en la Instalación Inicial",
  "Implement Make": "Marca del Implemento",
  "Budget at Setup": "Presupuesto en la Configuración",
  "Implement Tons at Setup": "Toneladas del Implemento en la Configuración",
  "Hours on Implement at Setup": "Horas del Implemento en la Configuración",
  "Skip Changes & Go To Next": "Omitir Cambios e Ir al Siguiente",
  "Save Changes & Go To Next": "Guardar Cambios e Ir al Siguiente",
  'System Calculated Usage': 'Uso Calculado por el Sistema',
  'Manually Entered Usage': 'Uso Ingresado Manualmente',
  'Eqiup Unit#': 'Número de Unidad del Equipo',
  "Please select an Implement to inspect first!": "Seleccione primero un implemento para inspeccionar!",
  "Equipment Smu at Install": "SMU del equipo en la instalación",
  "Equipment SMU at Inspection": "SMU del equipo en la inspección",
  "Include Cover Page on report": "Incluir portada en el informe",
  "Include Overall Comment on Report": "Incluir comentario general en el informe",
  "Work Required": "Trabajo requerido",
  "Job File #": "Número de archivo #",
  "Repair Request #": "Número de solicitud de reparación #",
  "Select Schematic to add an observation point/Crack (Click on thumbnail)": "Seleccione un esquema para agregar un punto de observación/grieta (haga clic en la miniatura)",
  "Part#": "Número de pieza #",
  "Wear Limit": "Límite de desgaste",
  "Question": "Pregunta",
  "Instructions": "Instrucciones",
  "Location Name": "Nombre de ubicación",
  "Obs. List": "Lista de obs.",
  "Severity List": "Lista de severidad",
  "Incl. Rep.": "Incl. en info.",
  "Refresh with Asset Type Report Options": "Actualizar con opciones de informe por tipo de activo",
  "ReCalculate Inspection": "Recalcular inspección",
  "Inspection Images": "Imágenes de inspección",
  "Observation Point View": "Vista del punto de observación",
  "Area Inspected": "Área inspeccionada",
  "Eng. Evaluation": "Evaluación de ingeniería",
  "Addressed To": "Dirigido a",
  "Location": "Ubicación",
  "Component Type comment for Report": "Comentario del tipo de componente para el informe",
  "Report Configuration": "Configuración del informe",
  "Pre-Inspection Checklist": "Lista de verificación previa a la inspección",
  "Tray Report Configuration": "Configuración del informe de la bandeja",
  "Save Report Configuration At Asset Type": "Guardar configuración de informe en tipo de activo",
  "Alternate Group Name": "Nombre alternativo del grupo",
  "Include in Report Summary": "Incluir en el resumen del informe",
  "Include Graph in Summary": "Incluir gráfico en el resumen",
  "Summary Eval": "Evaluación del resumen",
  "Include Schematic in Summary": "Incluir esquema en el resumen",
  "Image Rotation": "Rotación de imagen",
  "Summary Comment": "Comentario del resumen",
  "Enter a Summary Comment.": "Ingrese un comentario de resumen",
  "Include in Report Body": "Incluir en el cuerpo del informe",
  "Include Data Table": "Incluir tabla de datos",
  "Include Graph": "Incluir gráfico",
  "Pie Chart": "Gráfico circular",
  "Speedometer Chart": "Gráfico de velocímetro",
  'Undercarriage Rebuild Centre': 'Centro de Reconstrucción de Trenes de Rodaje',
  "Start New Undercarriage Rebuild Center": "Iniciar Nuevo Centro de Reconstrucción del Tren de Rodaje",
  "Find Undercarriage Rebuild Centre": "Buscar Centro de Reconstrucción del Tren de Rodaje",
  "Frame Undercarriage Rebuild Centre": "Centro de Reconstrucción del Tren de Rodaje (Bastidor)",
  "Chain Undercarriage Rebuild Centre": "Centro de Reconstrucción del Tren de Rodaje (Cadena)",
  "Alerts (Current)": 'Alertas (Actuales)',
  "Source": 'Fuente',
  "Move to History": 'Mover al historial',
  "Alert History": 'Historial de alertas',
  "Move to Current": 'Mover a actuales',
  'Selection': 'Selección',
  'Pass/Fail': 'Aprobado/Reprobado',
  'Yes/No': 'Sí/No',
  'Reading No.': 'Número de Lectura',
  'Accepted': 'Aceptado',
  'Monitor': 'Monitorear',
  'Not Accepted': 'No Aceptado',
  'Pass': 'Aprobado',
  'Fail': 'Reprobado',
  "NA": "N/A",
  "NO": "No",
  "YES": "Sí",
  "Enter Equipment Summary Notes...": "Ingrese notas resumidas del equipo...",
  "Created On": "Creado el",
  "Summary Notes": "Notas resumidas",
  "Last Modified On": "Última modificación el",
  "Last Modified By": "Última modificación por",
  "Edit Summary Notes": "Editar notas resumidas",
  "Equipment Summary Notes": "Notas resumidas del equipo",
  "DNET Cost": "Costo DNET",
  "Search Result": "Resultado de Búsqueda",
  "Request New Chain": "Solicitar Nueva Cadena",
  "Chain Des": "Descripción de Cadena",
  "Serial Number Start": "Número de Serie Inicial",
  "Serial Number End": "Número de Serie Final",
  "Pitch": "Paso",
  "# Of Links": "Nº de Enlaces",
  "Part Required": "Pieza Requerida",
  "Component Description": "Descripción del Componente",
  "PartLine": "Línea de Parte",
  "Quantity Required": "Cantidad Requerida",
  "Quantity in Stock": "Cantidad en Stock",
  "DNET  Cost Each": "Costo Unitario DNET",
  "DNET  Cost Total": "Costo Total DNET",
  "Add to Part List": "Agregar a Lista de Partes",
  "Request Part List": "Solicitar Lista de Partes",
  "Comments": "Comentarios",
  "Parts": "Partes",
  "Send Email": "Enviar Correo",
  "Summary Notes History": "Historial de Notas Resumidas",
  "Part Search": "Búsqueda de Pieza",
  "Request A New Chain": "Solicitar una Nueva Cadena",
  "Email is required": "El correo electrónico es obligatorio",
  "Email is invaild": "El correo electrónico no es válido",
  "Model Required": "Modelo Requerido",
  "A Model is required": "Se requiere un modelo",
  "Make Required": "Marca Requerida",
  "A Make is required": "Se requiere una marca",
  "Chain Description": "Descripción de la Cadena",
  "Edit Favourite": "Editar Favorito",
  "Update Favourite": "Actualizar Favorito",
  "Form Category": "Categoría del Formulario",
  "Select Form Category": "Seleccionar Categoría del Formulario",
  "Machine": "Máquina",
  "Select Machine": "Seleccionar Máquina",
  "Form Name": "Nombre del Formulario",
  "Select Form Name": "Seleccionar Nombre del Formulario",
  "Select Inspector": "Seleccionar Inspector",
  "Select Custom Date Range": "Seleccionar Rango de Fechas Personalizado",
  "Not Started": "No Iniciado",
  "In Progress": "En Progreso",
  "In Review": "En Revisión",
  "Completed": "Completado",
  "Attention Required": "Atención Requerida",
  "Multiple Answers": "Múltiples Respuestas",
  "Comment Added": "Comentario Agregado",
  "Show/Hide": "Mostrar/Ocultar",
  "SerialNo": "Número de Serie",
  "UnitNo": "Número de Unidad",
  "SMU Difference": "Diferencia SMU",
  "Serial no": "Número de Serie",
  "Unit no": "Número de Unidad",
  "SMR": "SMR",
  "Fail - Attention Required": "Fallo - Atención Requerida",
  "False/Unable to Answer - Immediate Action required": "Falso/No se Puede Responder - Acción Inmediata Requerida",
  "Report Options": "Opciones de Reporte",
  "Report Option": "Opción de Reporte",
  "Generate PDF": "Generar PDF",
  "In Progress/Completed": "En Progreso/Completado",
  "Available Forms": "Formularios Disponibles",
  "Linked Models": "Modelos Vinculados",
  "Linked Customers": "Clientes Vinculados",
  "Start New": "Iniciar Nuevo",
  "AVAILABLE FORMS": "FORMULARIOS DISPONIBLES",
  "Create New Form": "Crear Nuevo Formulario",
  "Copy": "Copiar",
  "Edit Form": "Editar Formulario",
  "Copy Form": "Copiar Formulario",
  "Select Asset/System Type": "Seleccionar Tipo de Activo/Sistema",
  "Select Asset Serial Number": "Seleccionar Número de Serie del Activo",
  "Add Serial Number": "Agregar Número de Serie",
  "Please use the Search field above to select what inspection you are shown.": "Utilice el campo de búsqueda anterior para seleccionar qué inspecciones desea visualizar.",
  "Warranty Type Setup": "Configuración del Tipo de Garantía",
  "Warranty Type": "Tipo de Garantía",
  "Enter Warranty Type Name": "Ingrese el Nombre del Tipo de Garantía",
  "Include": "Incluir",
  "Hours Usage": "Uso de Horas",
  "Enter Hours": "Ingrese Horas",
  "Enter Days": "Ingrese Días",
  "Cycles": "Ciclos",
  "Enter Cycles": "Ingrese Ciclos",
  "In-Active": "Inactivo",
  "Save/Update": "Guardar/Actualizar",
  "Product Improvement Program Search": "Búsqueda del Programa de Mejora de Producto",
  "Select Build #": "Seleccionar Build #",
  "Serial # Start": "Número de Serie Inicial",
  "Enter Serial # Start": "Ingrese Número de Serie Inicial",
  "Serial # End": "Número de Serie Final",
  "Enter Serial # End": "Ingrese Número de Serie Final",
  "PIP Number": "Número PIP",
  "Enter Heading": "Ingrese Encabezado",
  "Enter Heading Placeholder": "Ingrese Encabezado",
  "Program Start Date": "Fecha de Inicio del Programa",
  "Program End Date": "Fecha de Finalización del Programa",
  "PIP#": "PIP#",
  "Heading": "Encabezado",
  "Built #": "Build #",
  "SN# Start": "SN# Inicial",
  "SN# End": "SN# Final",
  "Support Pro.": "Programa de Soporte",
  "Show Less": "Mostrar Menos",
  "Show More": "Mostrar Más",
  "Asset SN#": "SN del Activo",
  "Unit#": "Unidad#",
  "Expired": "Expirado",
  "Product Improvement Program": "Programa de Mejora de Producto",
  "Return to Search Screen": "Volver a la Pantalla de Búsqueda",
  "Select Built #": "Seleccionar Build #",
  "Enter PIP Number": "Ingrese Número PIP",
  "Enter PIP Description": "Ingrese Descripción PIP",
  "Supporting Doc.": "Documento de Soporte",
  "Support Pro Associated with PIP": "Programa de Soporte Asociado al PIP",
  "Support Program Notes": "Notas del Programa de Soporte",
  "Enter Support Program Notes": "Ingrese Notas del Programa de Soporte",
  "Select Warranty Type": "Seleccionar Tipo de Garantía",
  "Select Start Date": "Seleccionar Fecha Inicial",
  "Enter Starting SMU": "Ingresar SMU Inicial",
  "Enter Starting Cycle #": "Ingresar Ciclo Inicial #",
  "Set Default": "Establecer Predeterminado",
  "Original Warranty": "Garantía Original",
  "Commencement Date": "Fecha de Inicio",
  "Commencement SMU": "SMU Inicial",
  "Original CMU": "CMU Original",
  "Residual Warranty": "Garantía Residual",
  "Current Date": "Fecha Actual",
  "Current SMU": "SMU Actual",
  "Current Cycles": "Ciclos Actuales",
  "Approval Request": "Solicitud de Aprobación",
  "Approval Response": "Respuesta de Aprobación",
  "% Complete": "% Completo",
  "Total Hours ": "Horas Totales",
  "Total Cost ": "Costo Total",
  "Product Improvement": "Mejora de Producto",
  "PIP No": "Número PIP",
  "Completed Date": "Fecha de Finalización",
  "PIP Notes": "Notas PIP",
  "Open": "Abierto",
  "View Photo": "Ver Foto",
  "Replace Photo": "Reemplazar Foto",
  "Repairer": "Reparador",
  "Implement Rebuild's Status": "Estado de Reconstrucción del Implemento",
  "Ready to Rebuild": "Listo para Reconstrucción",
  "Pre Shipped": "Pre-Enviado",
  "Shipped": "Enviado",
  "Disassembled": "Desmontado",
  "SOW-Approvals": "SOW-Aprobaciones",
  "WIP": "Trabajo en Progreso",
  "Ready to Ship": "Listo para Enviar",
  "Complete": "Completo",
  "Remove Component From Equipment": "Eliminar Componente del Equipo",
  "Create New Component": "Crear Nuevo Componente",
  "Clear History": "Limpiar Historial",
  "Make Setup": "Configuración de Marca",
  "Select Existing Make": "Seleccionar Marca Existente",
  "Make Details": "Detalles de la Marca",
  "Make ID": "ID de Marca",
  "Enter Make ID": "Ingrese ID de Marca",
  "Make Name": "Nombre de Marca",
  "Enter Make Name": "Ingrese Nombre de Marca",
  "OEM": "OEM",
  "Model Search": "Búsqueda de Modelo",
  "Family Setup": "Configuración de Familia",
  "Select Existing Family": "Seleccionar Familia Existente",
  "Family Details": "Detalles de la Familia",
  "Family ID": "ID de Familia",
  "Family Name": "Nombre de Familia",
  "Family Image": "Imagen de Familia",
  "Show Distance Travelled Tracking Option on Equipment Setup": "Mostrar opción de seguimiento de distancia recorrida en configuración del equipo",
  "Show Propel Hours and % on Equipment": "Mostrar horas de propulsión y % en el equipo",
  "Enable Equaliser Bar Type Fields": "Habilitar campos de tipo barra ecualizadora",
  "Enable Track Tension Indicator Installed Fields": "Habilitar campos del indicador de tensión de oruga",
  "Enable Frame Configuration": "Habilitar configuración de bastidor",
  "Enable Cannon Type": "Habilitar tipo de cañón",
  "Enable Bogie Shim": "Habilitar calza bogie",
  "Enable Manual Inspection Pdf": "Habilitar PDF de inspección manual",
  "Enable Track Sag": "Habilitar caída de oruga",
  "Enable Cannon Extension": "Habilitar extensión de cañón",
  "Enable Scallop": "Habilitar scallop",
  "Enable Dry Joints": "Habilitar juntas secas",
  "Enable # of Links": "Habilitar # de enlaces",
  "Enable Under Foot Conditions": "Habilitar condiciones bajo pie",
  "Enable Work Order": "Habilitar orden de trabajo",
  "Enable Thermal Image": "Habilitar imagen térmica",
  "Enable Additional Inspectors": "Habilitar inspectores adicionales",
  "Chain Image": "Imagen de Cadena",
  "Choose Chain Image": "Elegir imagen de cadena",
  "Frame Image": "Imagen de Bastidor",
  "Choose Frame Image": "Elegir imagen de bastidor",
  "Lookup": "Búsqueda",
  "Job Role": "Rol de Trabajo",
  "Role Name": "Nombre del Rol",
  "Role Notes": "Notas del Rol",
  "Admin Role": "Rol Administrador",
  "Update Roles": "Actualizar Roles",
  "Update Permissions": "Actualizar Permisos",
  "User Name": "Nombre de Usuario",
  "Select the model you would like to view/edit": "Seleccione el modelo que desea visualizar/editar",
  "No data available!": "¡No hay datos disponibles!",
  "Model Details": "Detalles del Modelo",
  "Model ID": "ID del Modelo",
  "Model Description": "Descripción del Modelo",
  "Industry": "Industria",
  "Default Inspection Cycle": "Ciclo de Inspección Predeterminado",
  "BaseModel": "Modelo Base",
  "Model Note": "Nota del Modelo",
  "Component Detail": "Detalle del Componente",
  "Upload to Mobile": "Subir a Móvil",
  "Chains Available": "Cadenas Disponibles",
  "Add Chain": "Agregar Cadena",
  "# of Links": "# de Enlaces",
  "No Of Links": "Número de Enlaces",
  "Link Height": "Altura del Enlace",
  "Number of Idlers": "Número de Rodillos Guía",
  "Bolt Hole Diameter": "Diámetro del Orificio del Perno",
  "Bushing Outside Diameter": "Diámetro Exterior del Buje",
  "Number Of CarrierRollers": "Número de Rodillos Portadores",
  "Chain Spread Inside": "Apertura Interior de Cadena",
  "Chain Spread Outside": "Apertura Exterior de Cadena",
  "Number Of TrackRollers": "Número de Rodillos de Oruga",
  "Hardware": "Hardware",
  "Berco Part Number": "Número de Parte Berco",
  "Case Part Number": "Número de Parte Case",
  "Quantity": "Cantidad",
  "Part Line": "Línea de Parte",
  "Component Details": "Detalles del Componente",
  "Component ID": "ID del Componente",
  "Component Type Availability": "Disponibilidad del Tipo de Componente",
  "Observation Details": "Detalles de Observación",
  "Mobile Screen Display of Observations:": "Visualización móvil de observaciones:",
  "Equipment Conditions": "Condiciones del Equipo",
  "Components Screen": "Pantalla de Componentes",
  "Visibility": "Visibilidad",
  "Update Limits": "Actualizar Límites",
  "Admin Role - allows edit functions in the equipment details screen": "Rol Administrador - permite funciones de edición en la pantalla de detalles del equipo",
  "Undercarriage Component Types": "Tipos de Componentes del Tren de Rodaje",
  "Component Image": "Imagen del Componente",
  "Component Family": "Familia del Componente",
  "Component Type Name": "Nombre del Tipo de Componente",
  "Information": "Información",
  "Please enter component extra details prior to sprocket hardware": "Ingrese detalles adicionales del componente antes del hardware del piñón",
  "Ok": "Ok",
  "Undercarriage Worn Limit Management": "Gestión de Límites de Desgaste del Tren de Rodaje",
  "Select Part #": "Seleccionar Parte #",
  "Select Tool Used": "Seleccionar Herramienta Utilizada",
  "High Impact": "Alto Impacto",
  "Low Impact": "Bajo Impacto",
  "Comp. Type": "Tipo Comp.",
  "Part #": "Parte #",
  "Method": "Método",
  "Tool Used": "Herramienta Utilizada",
  "Slope": "Pendiente",
  "Adjust to Base": "Ajustar a Base",
  "Inflect Pt.": "Punto de Inflexión",
  "Slope1": "Pendiente1",
  "Y Int.1": "Intersección Y1",
  "Slope2": "Pendiente2",
  "Y Int.2": "Intersección Y2",
  "Starting Dim": "Dimensión Inicial",
  "100% Worn": "100% Desgastado",
  "No records to display.": "No hay registros para mostrar.",
  "New High": "Nuevo Alto",
  "New Low": "Nuevo Bajo",
  "Polynomial Worn Limits": "Límites de Desgaste Polinómicos",
  "Impact 2nd Order": "Impacto 2do Orden",
  "Normal 2nd Order": "Normal 2do Orden",
  "Impact Slope": "Pendiente de Impacto",
  "Normal Slope": "Pendiente Normal",
  "Impact Intercept": "Intercepción de Impacto",
  "Normal Intercept": "Intercepción Normal",
  "Linear Worn Limits": "Límites de Desgaste Lineales",
  "Worn Limit Setup": "Configuración de Límite de Desgaste",
  "Method of Calculation": "Método de Cálculo",
  "Tools": "Herramientas",
  "U/C Make": "Marca U/C",
  "Adjustment to Base": "Ajuste a Base",
  "H.I. - Inflection Point": "H.I. - Punto de Inflexión",
  "M.I. - Inflection Point": "M.I. - Punto de Inflexión",
  "H.I. - Slope 1": "H.I. - Pendiente 1",
  "M.I. - Slope 1": "M.I. - Pendiente 1",
  "H.I. -Y Intercept 1": "H.I. - Intercepción Y 1",
  "M.I. -Y Intercept 1": "M.I. - Intercepción Y 1",
  "H.I. - Slope 2": "H.I. - Pendiente 2",
  "M.I. - Slope 2": "M.I. - Pendiente 2",
  "H.I. -Y Intercept 2": "H.I. - Intercepción Y 2",
  "M.I. -Y Intercept 2": "M.I. - Intercepción Y 2",
  "Worn Dimension": "Dimensión de Desgaste",
  "Impact": "Impacto",
  "Start Depth.New": "Profundidad Inicial.Nueva",
  "Wear Depth": "Profundidad de Desgaste",
  "Normal": "Normal",
  "Slope Direction - Impact": "Dirección de Pendiente - Impacto",
  "Slope Direction - Normal": "Dirección de Pendiente - Normal",
  "Add New Limit": "Agregar Nuevo Límite",
  "Add Dealer Group Branded Style": "Agregar Estilo de Marca del Grupo de Distribuidores",
  "Select Dealer Group": "Seleccionar Grupo de Distribuidores",
  "Colour Scheme": "Esquema de Colores",
  "Select Colour Scheme": "Seleccionar Esquema de Colores",
  "Upload a logo for the Dealer Group. Recommended 77px by 35px.": "Cargue un logotipo para el Grupo de Distribuidores. Recomendado 77px por 35px.",
  "Update Branded Style": "Actualizar Estilo de Marca",
  "Worn Spec": "Especificación de Desgaste",
  "Tolerance": "Tolerancia",
  "Plus": "Más",
  "Minus": "Menos",
  "Max": "Máximo",
  "Add Measurement Image": "Agregar Imagen de Medición",
  "Tool Name": "Nombre de la Herramienta",
  "Currently applying to": "Aplicando actualmente a",
  "selected machines": "máquinas seleccionadas",
  "For your selection the system is currently using the default ranges. These are shown below": "Para su selección el sistema está utilizando actualmente los rangos predeterminados. Estos se muestran a continuación",
  "For your selection site default limits display.These are shown below.": "Para su selección se muestran los límites predeterminados del sitio. Estos se muestran a continuación.",
  "Limit display for selected machine.": "Mostrar límites para la máquina seleccionada.",
  "For your selection the system is currently using the dealer ranges. These are shown below": "Para su selección el sistema está utilizando actualmente los rangos del distribuidor. Estos se muestran a continuación",
  "For your selection the system is currently using the customer ranges. These are shown below": "Para su selección el sistema está utilizando actualmente los rangos del cliente. Estos se muestran a continuación",
  "Create New Measurement Point": "Crear Nuevo Punto de Medición",
  "Rope Shovel/Hydraulic Shovel": "Pala de Cable/Pala Hidráulica",
  "URC": "URC",
  "Component Note": "Nota del Componente",
  "SMCS Job Code": "Código de Trabajo SMCS",
  "Budget Life (Hours)": "Vida Útil Presupuestada (Horas)",
  "Populate from USCO": "Completar desde USCO",
  "Component Make": "Marca del Componente",
  "Measurement Images": "Imágenes de Medición",
  "Unit number": "Número de Unidad",
  "Level": "Nivel",
  "Default Tool": "Herramienta Predeterminada",
  "Select a Default Tool": "Seleccione una Herramienta Predeterminada",
  "Please Select a default tool": "Seleccione una herramienta predeterminada",
  "True": "Verdadero",
  "False": "Falso",
  "Inspection Type cannot exceed 50 characters.": "El tipo de inspección no puede exceder los 50 caracteres.",
  "Standard Cost Repair": "Costo Estándar de Reparación",
  "Standard Hours Repair": "Horas Estándar de Reparación",
  "You can attach a photo of this measurement point ": "Puede adjuntar una foto de este punto de medición",
  "Add Measurement Points": "Agregar Puntos de Medición",
  "Copy Obs. Pts.": "Copiar Puntos de Obs.",
  "Select Filters to display and edit data": "Seleccione Filtros para mostrar y editar datos",
  "Component Setup": "Configuración de Componentes",
  "Component Search": "Búsqueda de Componentes",
  "Equipment Make": "Marca del Equipo",
  "Equipment Model": "Modelo del Equipo",
  "Default Tool Used": "Herramienta Predeterminada Utilizada",
  "Search and Review Forms": "Buscar y Revisar Formularios",
  "Enter Safety Inspection - Web Browser": "Ingresar Inspección de Seguridad - Navegador Web",
  "Search Safety Inspections": "Buscar Inspecciones de Seguridad",
  "Upload Completed Forms": "Subir Formularios Completados",
  "Configuration": "Configuración",
  "Add Take 5's": "Agregar Take 5",
  "Setup Induction Slides": "Configurar Diapositivas de Inducción",
  "Setup Induction Questions": "Configurar Preguntas de Inducción",
  "Setup Induction Types and Sections": "Configurar Tipos y Secciones de Inducción",
  "Safety Inspections": "Inspecciones de Seguridad",
  "Setup Safety Checklist": "Configurar Lista de Verificación de Seguridad",
  "Setup Digital Forms": "Configurar Formularios Digitales",
  "All State": "Todos los Estados",
  "All States": "Todos los Estados",
  "Checks Completed": "Verificaciones Completadas",
  "Current Count": "Conteo Actual",
  "Target for Month": "Objetivo del Mes",
  "Target for Date": "Objetivo para la Fecha",
  "Checks with Fails": "Verificaciones con Fallos",
  "Failed Items": "Elementos Fallidos",
  "Since Last Fail": "Desde el Último Fallo",
  "Incident Counts": "Conteo de Incidentes",
  "Last MTI": "Último MTI",
  "Last LTI": "Último LTI",
  "Focus Items": "Elementos de Enfoque",
  "Take 5's for Period": "Take 5 del Período",
  "Target": "Objetivo",
  "Actual": "Actual",
  "Previous 12 Mths Hours": "Horas de los Últimos 12 Meses",
  "Previous 12 Mths TRIFR": "TRIFR de los Últimos 12 Meses",
  "Last 12 Months": "Últimos 12 Meses",
  "Areas of Improvements": "Áreas de Mejora",
  "Positives": "Aspectos Positivos",
  "Activities": "Actividades",
  "Incidents": "Incidentes",
  "Observation Type": "Tipo de Observación",
  "Work Area": "Área de Trabajo",
  "Office": "Oficina",
  "Month-Year": "Mes-Año",
  "January": "Enero",
  "March": "Marzo",
  "April": "Abril",
  "June": "Junio",
  "July": "Julio",
  "August": "Agosto",
  "September": "Septiembre",
  "October": "Octubre",
  "November": "Noviembre",
  "December": "Diciembre",
  "Month": "Mes",
  "Year": "Año",
  "Number": "Número",
  "Add New Observation": "Agregar Nueva Observación",
  "Department": "Departamento",
  "Task Observed": "Tarea Observada",
  "Setup Departments": "Configurar Departamentos",
  "Add Work Area": "Agregar Área de Trabajo",
  "Add Department": "Agregar Departamento",
  "Incident Types": "Tipos de Incidente",
  "Add Incident Type": "Agregar Tipo de Incidente",
  "Setup Questions": "Configurar Preguntas",
  "Add Question": "Agregar Pregunta",
  "Add New Category": "Agregar Nueva Categoría",
  "Add Induction Type": "Agregar Tipo de Inducción",
  "Induction Type": "Tipo de Inducción",
  "Add Slide": "Agregar Diapositiva",
  "Safety Observation Search": "Búsqueda de Observación de Seguridad",
  "Select Work Area": "Seleccionar Área de Trabajo",
  "Select Category": "Seleccionar Categoría",
  "Select Department": "Seleccionar Departamento",
  "Select Contractor": "Seleccionar Contratista",
  "Select Question": "Seleccionar Pregunta",
  "Supplier": "Proveedor",
  "Follow Up Required": "Seguimiento Requerido",
  "Follow Up Completed": "Seguimiento Completado",
  "Only Unsafe": "Solo Inseguro",
  "Exclude N/A": "Excluir N/A",
  "Only Inspections": "Solo Inspecciones",
  "Show Department": "Mostrar Departamento",
  "Show Work Area": "Mostrar Área de Trabajo",
  "Show Observer": "Mostrar Observador",
  "Category": "Categoría",
  "Safe/Unsafe": "Seguro/Inseguro",
  "Unsafe": "Inseguro",
  "Safe": "Seguro",
  "Observer": "Observador",
  "No Data Found for this search criteria.": "No se encontraron datos para este criterio de búsqueda.",
  "Induction": "Inducción",
  "Select Induction Type": "Seleccionar Tipo de Inducción",
  "Select State": "Seleccionar Estado",
  "Facilitator": "Facilitador",
  "User (Already setup) being Inducted": "Usuario (ya configurado) siendo inducido",
  "User (Not setup) being Inducted": "Usuario (no configurado) siendo inducido",
  "Start": "Iniciar",
  "Slide": "Diapositiva",
  "Ans": "Respuesta",
  "Issue Start Date": "Fecha Inicial de Emisión",
  "Issue End Date": "Fecha Final de Emisión",
  "Document Heading": "Título del Documento",
  "Date Issued": "Fecha de Emisión",
  "Expiry Date": "Fecha de Expiración",
  "Field Changed": "Campo Modificado",
  "From": "Desde",
  "To": "Hasta",
  "New Leave Request": "Nueva Solicitud de Permiso",
  "Update Leave Request": "Actualizar Solicitud de Permiso",
  "Leave Requests": "Solicitudes de Permiso",
  "Leave Administration": "Administración de Permisos",
  "Leave Type": "Tipo de Permiso",
  "Leave From": "Permiso Desde",
  "Leave To": "Permiso Hasta",
  "Attach Doc.": "Adjuntar Documento",
  "Attachment": "Adjunto",
  "Administration By": "Administrado Por",
  "Approved By": "Aprobado Por",
  "Requested User": "Usuario Solicitante",
  "Field Change": "Cambio de Campo",
  "Filter user": "Filtrar usuario",
  "Filter customer": "Filtrar cliente",
  "Filter job site": "Filtrar sitio de trabajo",
  "Filter dealership": "Filtrar concesionario",
  "Filter dealer group": "Filtrar grupo de concesionarios",
  "Pending": "Pendiente",
  "Cancel Invite": "Cancelar Invitación",
  "Support Team Access": "Acceso del Equipo de Soporte",
  "Dealer Group Access": "Acceso al Grupo de Concesionarios",
  "Dealer Access": "Acceso del Concesionario",
  "Customer Access": "Acceso del Cliente",
  "Jobsite Access": "Acceso al Sitio de Trabajo",
  "Equipment Access": "Acceso al Equipo",
  "Reset Password": "Restablecer Contraseña",
  "Contact Email": "Correo de Contacto",
  "Job Sites/th": "Sitios de Trabajo",
  "Dealership": "Concesionario",
  "Dealership Name": "Nombre del Concesionario",
  "Safety Observation Dashboard": "Panel de Observaciones de Seguridad",
  "Safety General Dashboard": "Panel General de Seguridad",
  "Add Monthly Dashboard Messages": "Agregar Mensajes Mensuales al Panel",
  "Select a Form": "Seleccionar un Formulario",
  "Report / Incident # required": "Se requiere Reporte / Nº de Incidente",
  "Digital Form": "Formulario Digital",
  "Add Form": "Agregar Formulario",
  "Add Form Category": "Agregar Categoría de Formulario",
  "Upload Forms": "Subir Formularios",
  "Add File(s)": "Agregar Archivo(s)",
  "Related User": "Usuario Relacionado",
  "Add Image(s)": "Agregar Imagen(es)",
  "Report/Incident ID": "ID de Reporte/Incidente",
  "Incident Type": "Tipo de Incidente",
  "Follow Up Date": "Fecha de Seguimiento",
  "Follow Up User": "Usuario de Seguimiento",
  "Form Search": "Búsqueda de Formularios",
  "Date Start": "Fecha Inicio",
  "Date End": "Fecha Fin",
  "Form": "Formulario",
  "Person Responsible": "Persona Responsable",
  "Due Date Start": "Fecha de Vencimiento Inicio",
  "Due Date End": "Fecha de Vencimiento Fin",
  "Suspended User": "Usuario Suspendido",
  "Suspended Related Users": "Usuarios Relacionados Suspendidos",
  "Archived Forms": "Formularios Archivados",
  "Active Forms": "Formularios Activos",
  "Form Type": "Tipo de Formulario",
  "Add to Archive": "Agregar al Archivo",
  "All Positions": "Todos los Puestos",
  "All Forms": "Todos los Formularios",
  "All Users": "Todos los Usuarios",
  "Date Completed": "Fecha Completada",
  "Induction Search": "Búsqueda de Inducción",
  "First Name": "Nombre",
  "Last Name": "Apellido",
  "Company": "Empresa",
  "Show Valid": "Mostrar Válidos",
  "Show Invalid": "Mostrar Inválidos",
  "No Data Found - Please reset and try again.": "No se encontraron datos. Reinicie e intente nuevamente.",
  "VALID": "VÁLIDO",
  "Focus Item": "Elemento de Enfoque",
  "Areas Of Improvement": "Áreas de Mejora",
  "Take 5 target": "Objetivo Take 5",
  "Safety Inspection target": "Objetivo de Inspección de Seguridad",
  "Take 5 Target": "Objetivo Take 5",
  "Safety Inspection Target": "Objetivo de Inspección de Seguridad",
  "Select Equipment for Hire Report": "Seleccionar Equipo para Informe de Alquiler",
  "Idler Setup": "Configuración de Rodillo Guía",
  "Idler From Inventory": "Rodillo Guía desde Inventario",
  "Chain Setup": "Configuración de Cadena",
  "Chain From Inventory": "Cadena desde Inventario",
  "Frame Setup": "Configuración de Bastidor",
  "Frame From Inventory": "Bastidor desde Inventario",
  "Add New Inspection": "Agregar Nueva Inspección",
  "Additional Component Setup": "Configuración de Componente Adicional",
  "Additional Component Selection": "Selección de Componente Adicional",
  "Additional Component Details": "Detalles del Componente Adicional",
  "Select the component you would like to edit the measurement points for": "Seleccione el componente para el que desea editar los puntos de medición",
  "Model Image": "Imagen del Modelo",
  "Model Image Left": "Imagen Izquierda del Modelo",
  "Model Image Right": "Imagen Derecha del Modelo",
  "Average wear rates used in Forecasting": "Tasas promedio de desgaste utilizadas en la predicción",
  "Base Model": "Modelo Base",
  "Compart": "Compartimento",
  "Search Document in Library": "Buscar Documento en la Biblioteca",
  "Select Doc. Type": "Seleccionar Tipo de Documento",
  "Select Doc. Status": "Seleccionar Estado del Documento",
  "Select End Date": "Seleccionar Fecha de Finalización",
  "Doc. Type": "Tipo de Documento",
  "Add Document in Library": "Agregar Documento a la Biblioteca",
  "Edit Document in Library": "Editar Documento en la Biblioteca",
  "Automatically Add to Assets defined by above selection criteria": "Agregar automáticamente a los activos definidos por los criterios de selección anteriores",
  "Additional Component Name": "Nombre del Componente Adicional",
  "Select System": "Seleccionar Sistema",
  "No System": "Sin Sistema",
  "No Side": "Sin Lado",
  "Please select a Model": "Seleccione un Modelo",
  "Apply Models...": "Aplicar Modelos...",
  "You can attach a photo.": "Puede adjuntar una foto.",
  "JobSite": "Sitio de Trabajo",
  "Is Bogie": "Es Bogie",
  "UC Planner": "Planificador de Tren de Rodaje",
  "SMU & PMU Input": "Entrada de SMU y PMU",
  "Search URC": "Buscar URC",
  "New Undercarriage Rebuild Center": "Nuevo Centro de Reconstrucción de Tren de Rodaje",
  "MidPoint %": "Porcentaje del Punto Medio",
  'Inspection Document Register': 'Registro de Documentos de Inspección',
  'Include in Report (PDFs Only)': 'Incluir en el Informe (Solo PDFs)',
  'Attachments': 'Adjuntos',
  'Select Date': 'Seleccionar Fecha',
  'Select Document Type': 'Seleccionar Tipo de Documento',
  "Training Center": "Centro de Capacitación",
  "All Topics": "Todos los Temas",
  "Filter by Topic": "Filtrar por Tema",
  "Edit Additional Observation": "Editar Observación Adicional",
  'User Preferences ': 'Preferencias del Usuario',
  "Parts Search": "Búsqueda de piezas",
  'Report Name': 'Nombre del Informe',
  'Forecast Seasonal Date Ranges': 'Rangos de Fechas Estacionales de Pronóstico',
  'Season': 'Temporada',
};